const nav = document.querySelector(".header__icon-wrapper")

const search = document.querySelector('.header__search-bar')
const bodyTargetNode = document.body

const targetedElements = document.querySelectorAll('[id^="expanded-"]');

let eventRunning = false;


function isDesktop() {
    return window.innerWidth > 1024;
}

function toggleNav({ target }) {
    const expanded = nav.getAttribute('aria-expanded') === 'true';
    const isOpen = document.getElementById('mobile-menu-drawer').open;

    nav.setAttribute('aria-expanded', !expanded)
    document.getElementById('mobile-menu-drawer').open = !isOpen;
}

function updateChatButtonPositions(isOpening) {
    if (eventRunning) return;

    eventRunning = true; // Prevent multiple executions

    // this could change
    const chatButton = document.getElementById('gorgias-chat-container').querySelector('#chat-button');
    const chatButton2 = document.querySelector('.R-LauncherButton');

    const computedStyle2 = getComputedStyle(chatButton2);
    const top = parseFloat(computedStyle2.getPropertyValue('top')) || 0;
    const bottom = parseFloat(computedStyle2.getPropertyValue('bottom')) || 0;

    // Adjust positions based on the opening/closing state
    const chatButton2TopAdjustment = isOpening ? -60 : 60;
    const chatButton2BottomAdjustment = isOpening ? 60 : -60;

    // Adjust the bottom position of the chat button
    chatButton.style.bottom = isOpening ? "80px" : "20px";

    chatButton2.style.top = isOpening ? `${top + chatButton2TopAdjustment}px` : 'auto';
    chatButton2.style.bottom = `${bottom + chatButton2BottomAdjustment}px`;

    // Allow the next event to run immediately after
    setTimeout(() => {
        eventRunning = false;
    }, 0);
}

window.addEventListener("DOMContentLoaded", (event) => {

    // The drawer's currency picker is a bare <select> in a localization form, so
    // it needs something to submit it. Done here rather than with an inline
    // onchange so the markup stays free of handlers.
    const mobileCurrency = document.getElementById('mobile-currency-select');
    if (mobileCurrency) {
        mobileCurrency.addEventListener('change', function () {
            this.form.submit();
        });
    }

    /* Price match request.

       Delegated, not bound per-element at load: quick views inject their
       trigger long after this ran, so those triggers were dead clicks. The
       form (snippets/lux-form-price-match.liquid) is only rendered on the
       product page, so away from the PDP the trigger navigates to the
       product page with #price-match instead, and the PDP opens the form on
       arrival. A rare, high-consideration request reads better on the full
       product page anyway. */
    const openPriceMatchForm = (dataset) => {
        const dialog = document.querySelector('[data-lux-price-match]');
        if (!dialog || typeof dialog.showModal !== 'function') return false;
        const form = dialog.querySelector('form');
        const done = dialog.querySelector('[data-lux-form-done]');
        if (form && form.hidden) {
            form.hidden = false;
            if (done) done.hidden = true;
            const button = form.querySelector('[type="submit"]');
            if (button) button.disabled = false;
        }
        if (form) {
            const product = [dataset.name, dataset.variant].filter(function (v) { return v && v !== 'Default Title'; }).join(' ');
            if (product) form.elements.product.value = product;
            if (dataset.sku) form.elements.sku.value = dataset.sku;
            if (dataset.email && !form.elements.email.value) form.elements.email.value = dataset.email;
        }
        dialog.showModal();
        return true;
    };

    document.addEventListener('click', function (e) {
        if (e.target.closest('[data-lux-pm-close]')) {
            e.target.closest('dialog').close();
            return;
        }
        const el = e.target.closest('.price-match');
        if (!el) return;

        if (openPriceMatchForm(el.dataset)) return;

        // No form on this page: hand over to the PDP, which has it.
        if (el.dataset.url) {
            window.location.href = el.dataset.url + '#price-match';
        }
    });

    /* Arrival half of the hand-over. */
    if (window.location.hash === '#price-match') {
        const source = document.querySelector('[data-price-match]');
        if (source && openPriceMatchForm(source.dataset)) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
        }
    }

    document.querySelectorAll('.variant-image-btn').forEach(x => {
        x.addEventListener('click', function () {
            x.dataset.test = true;
            const zoomElement = document.querySelector('product-image-zoom');
            zoomElement.setAttribute('open', 'true');
        });
    })

    // nav 
    if (!isDesktop()) {
        document.addEventListener('mobile-nav:open', () => updateChatButtonPositions(true));
        document.addEventListener('mobile-nav:close', () => updateChatButtonPositions(false));
    }


    targetedElements.forEach(element => {
        element.addEventListener("change", function () {
            var labelSpan = this.parentElement.querySelector(".btn");

            if (this.checked) {
                labelSpan.textContent = "Say Less...";
            } else {
                labelSpan.textContent = "Read More...";
            }
        });
    });
})

if (isDesktop()) {
    const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const aaPanelElement = document.querySelector('.aa-Panel');
                if (aaPanelElement) {
                    document.documentElement.classList.add("lock-all");
                } else {
                    document.documentElement.classList.remove("lock-all");
                }
            }
        }
    };

    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Create an observer instance linked to the callback function
    const Desktopobserver = new MutationObserver(callback);

    // Assuming bodyTargetNode is already defined somewhere in your script
    Desktopobserver.observe(bodyTargetNode, config);

    // The results panel floated over a fully lit page, so nothing pulled the eye
    // to it. The mega menu already answers this with a black wash at 30%, so
    // reuse that rather than invent a second treatment for the same job.
    //
    // A ::after on .aa-Panel would be the obvious route, but the panel is
    // overflow:hidden and would clip it - hence a separate element sitting just
    // under the panel's z-index. It starts below the header because the search
    // input lives up there; dimming it would defeat the point.
    const searchOverlay = document.createElement('div');
    searchOverlay.className = 'search-overlay';
    bodyTargetNode.appendChild(searchOverlay);

    // Ten product hits on desktop (the five-across grid needs two full rows) is
    // set in snippets/algolia-search.liquid through the app embed's hooks.
}

// Collection card swatches: first click swaps the card image, second click
// (or clicking the main image) opens the product with that colour selected.
document.addEventListener('click', function (e) {
    const sw = e.target.closest('a[data-card-swatch]');
    if (!sw) return;
    const item = sw.closest('product-item');
    if (!item) return;
    if (sw.classList.contains('is-active')) return; // second click: navigate

    e.preventDefault();
    item.querySelectorAll('a[data-card-swatch].is-active').forEach(function (x) { x.classList.remove('is-active'); });
    sw.classList.add('is-active');

    const mid = sw.dataset.mediaId;
    if (mid) {
        const imgs = item.querySelectorAll('.product-item__primary-image');
        let found = false;
        imgs.forEach(function (img) {
            const match = img.dataset.mediaId === mid;
            if (match) found = true;
            img.hidden = !match;
        });
        if (!found) {
            imgs.forEach(function (img, i) { img.hidden = i !== 0; });
        }
    }

    const mainLink = item.querySelector('a[data-card-main-link]');
    if (mainLink) {
        mainLink.href = sw.getAttribute('href');
    }

    const priceList = item.querySelector('.price-list');
    if (priceList && sw.dataset.price) {
        let html = '<span class="price">';
        if (sw.dataset.from) html += '<span class="text--xsmall">From</span> ';
        html += '<p class="tw-font-extrabold tw-inline tw-m-0">' + sw.dataset.price + '</p></span>';
        if (sw.dataset.compare) {
            html += ' <span class="price price--compare">' + sw.dataset.compare + '</span>';
        }
        priceList.innerHTML = html;
    }

});

/* A row offering exactly one choice is not a choice - show it as chosen.

   Otherwise a single "2.4 Inch" pill sits there looking unselected, implying
   the shopper still has a decision to make, when that variant is already what
   the tile is quoting and what the wishlist button will save.

   Sold-out sole options are left alone: marking the only option selected when
   it cannot be bought would misrepresent it. */
function preselectSoleOptions(item) {
    const activateIfAlone = (row, selector) => {
        const choices = row.querySelectorAll(selector);
        if (choices.length !== 1) return;
        const only = choices[0];
        if (only.dataset.unavailable === 'true') return;
        only.classList.add('is-active');
        // Marked so the tile can keep it looking like any other option until
        // the shopper picks it themselves (lux-tile-a.css).
        only.dataset.autoActive = 'true';
    };

    item.querySelectorAll('.product-item-meta__options-list').forEach(function (row) {
        activateIfAlone(row, 'a.card-option-pill');
    });
    // Swatch rows carry the options-list class too, so exclude those or a sole
    // pill row would be treated as a swatch row and matched twice.
    item.querySelectorAll('.color-swatch-list:not(.product-item-meta__options-list)').forEach(function (row) {
        activateIfAlone(row, 'a[data-card-swatch]');
    });
}

document.querySelectorAll('product-item').forEach(preselectSoleOptions);

/* Option pills (size and similar) behave like the colour swatches above:
   first click selects, second click opens the product.

   They used to navigate on the first click, so choosing a size was impossible
   without leaving the collection - and the wishlist button could never learn
   about a size the shopper picked. Unlike swatches these carry no media id, so
   there is no image to swap; a size does not change the photograph. */
document.addEventListener('click', function (e) {
    const pill = e.target.closest('a.card-option-pill');
    if (!pill) return;
    const item = pill.closest('product-item');
    if (!item) return;
    if (pill.classList.contains('is-active')) return; // second click: navigate
    if (pill.dataset.unavailable === 'true') return;

    e.preventDefault();
    // Scoped to the pill's own row so a product with two pill rows keeps one
    // active selection per option rather than clearing the other row.
    const row = pill.parentElement;
    row.querySelectorAll('a.card-option-pill.is-active').forEach(function (x) { x.classList.remove('is-active'); });
    pill.classList.add('is-active');

    const mainLink = item.querySelector('a[data-card-main-link]');
    if (mainLink) mainLink.href = pill.getAttribute('href');

});

// Mark scrollable card swatch rows (fade + desktop scrollbar) and let the
// mouse wheel scroll them horizontally.
/* ---------------------------------------------------------------------------
   Horizontal scroller affordance - one implementation for every rail on the
   site (tile swatch/option rows, filter pills, PDP thumbnails, upsell and
   recommendation carousels). The theme's `hide-scrollbar` removes the only cue
   a row has more content and puts nothing back, so a clipped row reads as a
   complete one. `.lux-scroller` restores it: a mask fade on whichever edge has
   content beyond it, plus drag and wheel scrolling.

   Fades BOTH edges - the old swatch-only version faded the right only, so once
   you had scrolled there was no hint you could go back.
   --------------------------------------------------------------------------- */
const LUX_SCROLLER = '.lux-scroller';

function luxUpdateScroller(el) {
    // A collapsed/unsettled layout reports bogus widths; leave it alone
    if (el.clientWidth < 60) {
        el.classList.remove('has-overflow', 'at-start', 'at-end');
        return;
    }
    const overflows = el.scrollWidth > el.clientWidth + 2;
    el.classList.toggle('has-overflow', overflows);
    if (!overflows) {
        el.classList.remove('at-start', 'at-end');
        return;
    }
    el.classList.toggle('at-start', el.scrollLeft <= 2);
    el.classList.toggle('at-end', el.scrollLeft + el.clientWidth >= el.scrollWidth - 2);
}

function markScrollers(root) {
    (root || document).querySelectorAll(LUX_SCROLLER).forEach(luxUpdateScroller);
}

// Kept: other call sites (facet re-render, Load more) still ask for this by name
function markSwatchOverflow() {
    markScrollers();
}

// A rail's width changes without the window resizing - a card reflowing, a
// drawer opening, tiles appended by Load more. Watch the elements themselves.
const luxScrollerResize = window.ResizeObserver
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) { luxUpdateScroller(entry.target); });
    })
    : null;

function luxBindScrollers(root) {
    (root || document).querySelectorAll(LUX_SCROLLER).forEach(function (el) {
        if (el.dataset.luxScrollerBound) return;
        el.dataset.luxScrollerBound = '1';
        if (luxScrollerResize) luxScrollerResize.observe(el);
        luxUpdateScroller(el);
    });
}

document.addEventListener('scroll', function (e) {
    const el = e.target;
    if (!el.classList || !el.classList.contains('lux-scroller')) return;
    luxUpdateScroller(el);
}, true);

document.addEventListener('wheel', function (e) {
    const el = e.target.closest && e.target.closest('.lux-scroller.has-overflow');
    if (!el) return;
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    el.scrollLeft += e.deltaY;
    e.preventDefault();
}, { passive: false });

window.addEventListener('DOMContentLoaded', function () { luxBindScrollers(); });
window.addEventListener('load', function () { luxBindScrollers(); });
window.addEventListener('resize', function () { markScrollers(); });
document.addEventListener('theme:loading:end', function () { setTimeout(luxBindScrollers, 300); });

// Sections re-render (facets, cart drawer, recommendations) bring their own
// rails. Watch childList ONLY - this callback writes classes and a data
// attribute onto elements inside the observed tree, and observing attributes
// would make those writes retrigger it.
(function () {
    if (!window.MutationObserver) return;
    let pending = null;
    const observer = new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () {
            pending = null;
            luxBindScrollers();
        }, 150);
    });
    const start = function () {
        observer.observe(document.body, { childList: true, subtree: true });
        luxBindScrollers();
    };
    if (document.body) start();
    else window.addEventListener('DOMContentLoaded', start);
})();
document.addEventListener('theme:loading:end', function () { setTimeout(markSwatchOverflow, 500); });

// Click-and-drag scrolling for any .lux-scroller rail (desktop).
(function () {
    let dragList = null;
    let dragStartX = 0;
    let dragStartScroll = 0;
    let dragged = false;

    document.addEventListener('mousedown', function (e) {
        const list = e.target.closest && e.target.closest('.lux-scroller.has-overflow');
        if (!list || e.button !== 0) return;
        dragList = list;
        dragStartX = e.pageX;
        dragStartScroll = list.scrollLeft;
        dragged = false;
    });

    document.addEventListener('mousemove', function (e) {
        if (!dragList) return;
        const dx = e.pageX - dragStartX;
        if (!dragged && Math.abs(dx) > 4) {
            dragged = true;
            dragList.classList.add('is-dragging');
        }
        if (dragged) {
            dragList.scrollLeft = dragStartScroll - dx;
            e.preventDefault();
        }
    });

    document.addEventListener('mouseup', function () {
        if (!dragList) return;
        const list = dragList;
        dragList = null;
        if (dragged) {
            // swallow the click that follows a drag so it doesn't select/navigate
            const swallow = function (e) {
                if (list.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                document.removeEventListener('click', swallow, true);
            };
            document.addEventListener('click', swallow, true);
            setTimeout(function () {
                document.removeEventListener('click', swallow, true);
                list.classList.remove('is-dragging');
            }, 50);
        }
    });

    document.addEventListener('dragstart', function (e) {
        if (e.target.closest && e.target.closest('.lux-scroller')) e.preventDefault();
    });
})();

// Hide card swatches/option pills that don't match the active collection filters
// (availability, colour group, and any variant option filters).
function applyCardFilterVisibility() {
    const params = new URLSearchParams(location.search);
    const availAliases = {
        'in stock at luxbmx': ['ready to ship'],
        'available to order': ['available'],
        'out of stock': ['out of stock']
    };
    const availSel = [];
    params.getAll('filter.v.m.variant.availability').forEach(function (v) {
        let label = v;
        if (v.indexOf('gid://') === 0) {
            const input = document.querySelector('input[name="filter.v.m.variant.availability"][value="' + CSS.escape(v) + '"]');
            if (input) {
                if (input.dataset.filterLabel) {
                    label = input.dataset.filterLabel;
                } else {
                    const lab = input.closest('label') || (input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null) || input.parentElement;
                    if (lab) label = lab.textContent;
                }
            }
        }
        const key = label.toLowerCase().replace(/[\u200e\u200f\u00a0]/g, ' ').replace(/\s*\(\d+\)\s*$/, '').trim();
        (availAliases[key] || [key]).forEach(function (raw) { availSel.push(raw); });
    });
    const colourSel = params.getAll('filter.v.m.custom.colour-group');
    const optionSel = {};
    for (const [k, v] of params.entries()) {
        const m = k.match(/^filter\.v\.option\.(.+)$/);
        if (m) {
            const key = decodeURIComponent(m[1]).toLowerCase();
            (optionSel[key] = optionSel[key] || []).push(v.toLowerCase());
        }
    }
    const anyActive = availSel.length || colourSel.length || Object.keys(optionSel).length;

    var showUnavail = false;
    try { showUnavail = localStorage.getItem('lux-show-unavailable') === '1'; } catch (e) { /* storage unavailable */ }

    document.querySelectorAll('a[data-card-swatch], a.card-option-pill').forEach(function (a) {
        const holder = a.closest('.color-swatch') || a;
        // Sold-out variants are always in the markup; only reveal them on request.
        if (!showUnavail && a.dataset.unavailable === 'true') { holder.classList.add('is-filter-hidden'); return; }
        if (!anyActive) { holder.classList.remove('is-filter-hidden'); return; }
        let hide = false;
        if (availSel.length && a.dataset.avail) {
            const list = a.dataset.avail.toLowerCase().split('|');
            if (!availSel.some(function (x) { return list.indexOf(x) !== -1; })) hide = true;
        }
        if (!hide && colourSel.length && a.dataset.colourGroup) {
            // colour-group is a list metafield: markup carries '["colour-black"]'
            var cgRaw = a.dataset.colourGroup, cgList;
            if (cgRaw.charAt(0) === '[') {
                try { cgList = JSON.parse(cgRaw); } catch (e) { cgList = [cgRaw]; }
            } else {
                cgList = cgRaw.split('|');
            }
            var cgMatch = cgList.some(function (c) { return colourSel.indexOf(String(c).trim()) !== -1; });
            if (!cgMatch) hide = true;
        }
        if (!hide && a.dataset.opts) {
            // Combo pill: "name1:value1||name2:value2" - every filtered option must match
            a.dataset.opts.split('||').forEach(function (pair) {
                var i = pair.indexOf(':');
                if (i === -1) return;
                var n = pair.slice(0, i).trim(), val = pair.slice(i + 1).trim().toLowerCase();
                if (optionSel[n] && optionSel[n].indexOf(val) === -1) hide = true;
            });
        } else if (!hide && a.dataset.optionName && optionSel[a.dataset.optionName]) {
            if (optionSel[a.dataset.optionName].indexOf((a.dataset.optionValue || '').toLowerCase()) === -1) hide = true;
        }
        holder.classList.toggle('is-filter-hidden', hide);
    });

    // Recompute centring from the VISIBLE swatch count so filtered-down
    // rows centre like their server-rendered equivalents would.
    document.querySelectorAll('.product-item-meta__swatch-list:not(.product-item-meta__options-list)').forEach(function (list) {
        const visible = list.querySelectorAll('.color-swatch:not(.is-filter-hidden)').length;
        if (!visible) return;
        list.classList.toggle('swatch-centre-mobile', visible <= 3);
        list.classList.toggle('swatch-centre-desktop', visible <= 4);
    });
    markSwatchOverflow();
}
window.addEventListener('DOMContentLoaded', applyCardFilterVisibility);
window.addEventListener('popstate', applyCardFilterVisibility);
document.addEventListener('theme:loading:end', function () { setTimeout(applyCardFilterVisibility, 300); });

// Facet AJAX swaps the card DOM after our passes have run - re-apply
// filter visibility + overflow marking whenever new cards appear.
(function () {
    let cardVisTimer = null;
    const observer = new MutationObserver(function (mutations) {
        for (const m of mutations) {
            for (const n of m.addedNodes) {
                if (n.nodeType !== 1) continue;
                if ((n.matches && n.matches('product-item')) || (n.querySelector && n.querySelector('product-item'))) {
                    clearTimeout(cardVisTimer);
                    cardVisTimer = setTimeout(function () {
                        applyCardFilterVisibility();
                        setTimeout(applyCardFilterVisibility, 1200);
                    }, 250);
                    return;
                }
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
})();

/* ---- Sticky "Ready to ship or pickup" toggle ---------------------------
   The chip (snippets/filter-pills.liquid) is a checkbox inside the facet
   form, so checking it applies the availability filter via the theme's
   facet AJAX. The preference persists in localStorage and is re-applied
   on every collection page until the user switches it off or clears
   filters. */
(function () {
    var READY_KEY = 'lux-ready-filter';

    function readyInput() {
        return document.querySelector('[data-ready-toggle] .ready-toggle__input');
    }

    // Keep storage in sync with every facet change (chip, drawer, clear-filters)
    document.addEventListener('facet:criteria-changed', function (event) {
        var input = readyInput();
        if (!input || !event.detail || !event.detail.url) return;
        try {
            var params = new URL(event.detail.url, location.origin).searchParams;
            // "on" means LUX stock only - the auto-applied in-stock-or-orderable
            // pair also contains this value and must not count as the toggle.
            var vals = params.getAll(input.name);
            if (vals.length === 1 && vals[0] === input.value) {
                localStorage.setItem(READY_KEY, '1');
            } else {
                localStorage.removeItem(READY_KEY);
            }
        } catch (e) { /* storage unavailable */ }
    });

    function applyStoredPreference() {
        try {
            if (!localStorage.getItem(READY_KEY)) return;
        } catch (e) {
            return;
        }
        var input = readyInput();
        if (!input || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyStoredPreference);
    } else {
        applyStoredPreference();
    }
})();

/* ---- "Show unavailable options" -------------------------------------------
   Unticked (default): filtered results are constrained to variants that are
   in stock at LUXBMX or orderable from a supplier, so complex filter
   combinations stop surfacing sold-out variants. Ticked: no constraint.
   The availability values are resolved from the drawer's own checkbox labels
   so renaming them in Search & Discovery can't break this. */
(function () {
    var SU_KEY = 'lux-show-unavailable';
    var AVAIL = 'filter.v.m.variant.availability';

    function showUnavailable() {
        // Collections with custom.show_sold_out on never add the in-stock constraint.
        if (document.querySelector('product-list[data-show-sold-out]')) return true;
        try { return localStorage.getItem(SU_KEY) === '1'; } catch (e) { return false; }
    }

    // Drives the CSS that hides sold-out tiles.
    function reflectOnBody() {
        document.body.classList.toggle('lux-show-unavailable', showUnavailable());
    }

    function availValues() {
        var map = { lux: null, supplier: null, out: null };
        document.querySelectorAll('input[name="' + AVAIL + '"]').forEach(function (i) {
            // Drawer markup labels by `for`; the pills wrap the input in a label.
            var lab = i.closest('label')
                || (i.id ? document.querySelector('label[for="' + CSS.escape(i.id) + '"]') : null)
                || i.parentElement;
            var t = (lab ? lab.textContent : '').toLowerCase().replace(/[‎‏ ]/g, ' ');
            if (t.indexOf('out of stock') !== -1) map.out = i.value;
            else if (t.indexOf('in stock at luxbmx') !== -1 || t.indexOf('ready to ship') !== -1) map.lux = i.value;
            else if (t.indexOf('available to order') !== -1 || t.indexOf('supplier') !== -1) map.supplier = i.value;
        });
        return map;
    }

    // Runs before the theme's facet listener (capture) so the request that goes
    // to Shopify already carries the availability constraint.
    document.addEventListener('facet:criteria-changed', function (event) {
        if (!event.detail || !event.detail.url || showUnavailable()) return;
        var av = availValues();
        if (!av.lux || !av.supplier) return;
        var url;
        try { url = new URL(event.detail.url, location.origin); } catch (e) { return; }
        var vals = url.searchParams.getAll(AVAIL).filter(function (v) { return v !== av.out; });
        if (!vals.length) vals = [av.lux, av.supplier];
        url.searchParams.delete(AVAIL);
        vals.forEach(function (v) { url.searchParams.append(AVAIL, v); });
        event.detail.url = url.pathname + url.search;
    }, true);

    document.addEventListener('change', function (event) {
        var box = event.target;
        if (!box.closest || !box.closest('[data-show-unavailable]')) return;
        try {
            if (box.checked) localStorage.setItem(SU_KEY, '1');
            else localStorage.removeItem(SU_KEY);
        } catch (e) { /* storage unavailable */ }

        reflectOnBody();

        var params = new URLSearchParams(location.search);
        if (box.checked) {
            // Showing everything and "Available today" are opposites: drop any
            // availability constraint and switch the other toggle off.
            params.delete(AVAIL);
            try { localStorage.removeItem('lux-ready-filter'); } catch (e) { /* storage unavailable */ }
            document.querySelectorAll('[data-ready-toggle] .ready-toggle__input').forEach(function (i) { i.checked = false; });
        }
        applyCardFilterVisibility();
        var host = document.querySelector('product-facet') || document.body;
        host.dispatchEvent(new CustomEvent('facet:criteria-changed', {
            bubbles: true,
            detail: { url: location.pathname + (params.toString() ? '?' + params.toString() : '') }
        }));
    }, true);

    // Ticking "Available today" is the inverse: stop showing unavailable stock.
    // Capture phase so this lands before the theme serialises the form.
    document.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.name || input.name !== AVAIL || !input.checked) return;
        var av = availValues();
        if (input.value !== av.lux) return;
        try { localStorage.removeItem(SU_KEY); } catch (e) { /* storage unavailable */ }
        document.querySelectorAll('[data-show-unavailable] input').forEach(function (i) { i.checked = false; });
    }, true);

    // The in-stock-or-orderable pair is applied for the shopper, not chosen by
    // them, so it shouldn't appear as removable tags or inflate the filter count.
    function tidyAutoTags() {
        if (showUnavailable()) return;
        var av = availValues();
        if (!av.lux || !av.supplier) return;
        var cur = new URLSearchParams(location.search).getAll(AVAIL);
        var isAutoPair = cur.length === 2 && cur.indexOf(av.lux) !== -1 && cur.indexOf(av.supplier) !== -1;
        if (!isAutoPair) return;
        var hidden = 0;
        document.querySelectorAll('.product-facet__active-list .tag').forEach(function (tag) {
            var link = tag.querySelector('a[data-action="clear-filters"]');
            if (!link) return;
            var after;
            try { after = new URL(link.href, location.origin).searchParams.getAll(AVAIL); } catch (e) { return; }
            var removed = cur.filter(function (v) { return after.indexOf(v) === -1; });
            if (removed.length === 1 && (removed[0] === av.lux || removed[0] === av.supplier)) {
                tag.classList.add('is-auto-filter');
                hidden++;
            }
        });
        document.querySelectorAll('.product-facet__active-count').forEach(function (badge) {
            // Always recompute from the server-rendered value; this runs on
            // every facet render and must not compound its own subtraction.
            if (!badge.dataset.rawCount) badge.dataset.rawCount = badge.textContent.trim();
            var n = parseInt(badge.dataset.rawCount, 10);
            if (isNaN(n)) return;
            var left = n - hidden;
            var next = String(left > 0 ? left : badge.dataset.rawCount);
            if (badge.textContent.trim() !== next) badge.textContent = next;
            badge.classList.toggle('is-auto-filter', left <= 0);
        });
    }

    var queued = false;

    // The drawer is replaced wholesale on every facet render, so re-apply state.
    function syncCheckbox() {
        document.querySelectorAll('[data-show-unavailable] input').forEach(function (box) {
            box.checked = showUnavailable();
        });
        reflectOnBody();
        tidyAutoTags();
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncCheckbox);
    } else {
        syncCheckbox();
    }
    // syncCheckbox mutates the DOM it is watching, so pause the observer while
    // it runs (otherwise it retriggers itself and locks the page up) and
    // coalesce the storm of records a facet re-render produces.
    var facetHost = document.querySelector('product-facet');
    if (facetHost) {
        var observer = new MutationObserver(function () {
            if (queued) return;
            queued = true;
            // setTimeout rather than rAF: rAF is throttled in background tabs
            // (and frozen in some embedded browsers), which would strand this.
            setTimeout(function () {
                queued = false;
                observer.disconnect();
                try { syncCheckbox(); } finally {
                    observer.observe(facetHost, { childList: true, subtree: true });
                }
            });
        });
        observer.observe(facetHost, { childList: true, subtree: true });
    }
})();

/* ---- Load more -----------------------------------------------------------
   Appends the next page into the existing grid instead of replacing it.
   The theme's numbered pagination stays in the DOM (crawlable, no-JS
   fallback) and is hidden by CSS while the button is present. */
(function () {
    var loading = false;

    function gridInner() {
        return document.querySelector('product-list .product-list__inner');
    }

    async function loadMore(btn) {
        if (loading) return;
        loading = true;
        var label = btn.querySelector('[data-load-more-label]');
        var original = label ? label.textContent : '';
        if (label) label.textContent = 'Loading…';
        btn.disabled = true;

        try {
            var facet = document.querySelector('product-facet');
            var url = new URL(btn.dataset.nextUrl, location.origin);
            // Carry the active filters/sort, then ask for just this section.
            new URLSearchParams(location.search).forEach(function (v, k) {
                if (k !== 'page') url.searchParams.set(k, v);
            });
            if (facet && facet.getAttribute('section-id')) {
                url.searchParams.set('section_id', facet.getAttribute('section-id'));
            }

            var html = await (await fetch(url.toString())).text();
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelector('product-list .product-list__inner');
            var target = gridInner();
            if (!incoming || !target) throw new Error('grid not found');

            Array.prototype.slice.call(incoming.children).forEach(function (node) {
                node.removeAttribute('reveal');
                target.appendChild(node);
            });

            // Hand over to the next page, or retire the button at the end.
            var nextBtn = doc.querySelector('[data-load-more]');
            var wrap = btn.closest('[data-load-more-wrap]');
            if (nextBtn) {
                btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
                btn.dataset.nextPage = nextBtn.dataset.nextPage;
                var count = doc.querySelector('[data-load-more-count]');
                var ourCount = document.querySelector('[data-load-more-count]');
                if (count && ourCount) ourCount.textContent = count.textContent;
                if (label) label.textContent = original;
                btn.disabled = false;
            } else if (wrap) {
                wrap.remove();
                document.querySelectorAll('.pagination').forEach(function (p) { p.classList.add('is-exhausted'); });
            }

            if (typeof applyCardFilterVisibility === 'function') applyCardFilterVisibility();
            if (typeof markSwatchOverflow === 'function') markSwatchOverflow();
        } catch (e) {
            if (label) label.textContent = original;
            btn.disabled = false;
        } finally {
            loading = false;
        }
    }

    document.addEventListener('click', function (event) {
        var btn = event.target.closest && event.target.closest('[data-load-more]');
        if (!btn) return;
        event.preventDefault();
        loadMore(btn);
    });
})();

/* ---- Sticky offset -------------------------------------------------------
   The theme's --header-height reports the desktop height on mobile and doesn't
   follow the header collapsing on scroll, which left a gap under the sticky
   filter bar. Measure the header for real instead. */
(function () {
    var header = document.querySelector('store-header') || document.querySelector('.header');
    if (!header) return;

    var last = -1;
    function update() {
        var h = Math.round(header.getBoundingClientRect().height);
        if (h === last) return;
        last = h;
        // Tuck under the header (which sticks at top: -1px) so rounding or a
        // collapsing header can never open a gap; z-index keeps it behind.
        document.documentElement.style.setProperty('--lux-sticky-offset', Math.max(0, h - 3) + 'px');
    }

    update();
    window.addEventListener('load', update);
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(header);
})();

/* ---- PDP SKU on variant change -------------------------------------------
   theme.js `_updateSku` reads `sku` off the variant:changed payload, but that
   payload only carries id / options / available / price / compare_at_price /
   featured_media. `variant.sku` is therefore always undefined and it HIDES the
   SKU on every variant change - the number you are left looking at belongs to
   the variant you started on.

   The bug predates showing SKU under the title; it was simply invisible while
   the theme setting was off. Rather than patch vendor theme.js, read the sku
   from buy-grid's own variant payload, which does carry it, and correct the row
   on the next frame - after the theme's handler has run and hidden it. */
(function () {
    // buy-grid renders after this file executes, so its variant payload is not
    // in the DOM yet - bind once the document is parsed rather than depending on
    // script order.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
    var meta = document.querySelector('product-meta');
    var container = document.querySelector('[data-product-sku-container]');
    var number = document.querySelector('[data-product-sku-number]');
    var payload = document.querySelector('[data-buy-grid-variants]');
    if (!meta || !container || !number || !payload) return;

    var skuById = {};
    try {
        (JSON.parse(payload.textContent) || []).forEach(function (v) {
            if (v && v.id != null) skuById[String(v.id)] = v.sku;
        });
    } catch (e) {
        return;
    }

    var form = document.getElementById(meta.getAttribute('form-id'));
    if (!form) return;

    var binWrap = document.querySelector('[data-product-bin]');
    var binText = document.querySelector('[data-product-bin-text]');

    // Stands in for a pick location the variant does not have. Staff need to see
    // that the location is genuinely absent rather than that nothing happened.
    // It is deliberately NOT a copy target - see setBin below.
    // Keep in step with the same placeholder in snippets/product-info.liquid,
    // which renders the first paint before this file runs.
    var NO_BIN = '-';

    // One place that renders a bin, so the two variant paths below cannot drift.
    // An absent bin drops data-copy-sku entirely: leaving it empty would keep the
    // element a copy target, so a click would put "" on the clipboard and still
    // flash "Copied ✓".
    function setBin(bin) {
        if (!binText) return;
        binText.textContent = bin || NO_BIN;
        if (bin) {
            binText.setAttribute('data-copy-sku', bin);
        } else {
            binText.removeAttribute('data-copy-sku');
        }
    }

    var binById = {};
    try {
        (JSON.parse(payload.textContent) || []).forEach(function (v) {
            if (v && v.id != null) binById[String(v.id)] = v.bin;
        });
    } catch (e) { /* leave bins empty; the SKU still copies */ }

    // Clicking the SKU copies it (the shared [data-copy-sku] handler does that)
    // and toggles the pick location - the pair that used to live behind the buy
    // grid's popovers.
    //
    // The panel opens even when there is no pick location. It used to return
    // early on an empty bin, so staff clicking a location-less SKU got nothing
    // at all and could not tell "no location" from "the click didn't register".
    // NO_BIN is shown instead.
    number.addEventListener('click', function () {
        if (number.disabled || !binWrap) return;
        binWrap.hidden = !binWrap.hidden;
    });

    // buy-grid resolves and announces a variant on load even when the shopper
    // has picked nothing - on a product whose only Size value is auto-selected,
    // that meant the server's "Select Options" placeholder was immediately
    // overwritten with the first variant's SKU while the button still read
    // "Choose Options". Defer to the grid's own completeness test.
    var grid = document.querySelector('buy-grid');
    function selectionIncomplete() {
        return !!(grid && typeof grid.isIncomplete === 'function' && grid.isIncomplete());
    }

    function applyVariant(variantId) {
        var pendingLabel = number.getAttribute('data-sku-pending-label') || 'Select Options';
        if (selectionIncomplete()) {
            number.textContent = pendingLabel;
            number.classList.add('product-meta__identity-value--pending');
            number.disabled = true;
            number.setAttribute('data-product-bin-value', '');
            container.style.display = '';
            if (binWrap) binWrap.hidden = true;
            return;
        }
        var sku = variantId ? skuById[String(variantId)] : null;
        var bin = variantId ? binById[String(variantId)] : null;
        if (!sku) return;
        number.textContent = sku;
        number.setAttribute('data-copy-sku', sku);
        number.setAttribute('data-product-bin-value', bin || '');
        number.disabled = false;
        number.classList.remove('product-meta__identity-value--pending');
        container.style.display = '';
        setBin(bin);
        if (binWrap) binWrap.hidden = true;
    }

    // Reconcile the state we were rendered with, not just later changes. When
    // every option has a single value - "Black" / "One Size" - buy-grid
    // auto-selects them as it initialises and announces the variant BEFORE this
    // file has bound, so the server's "Select Options" placeholder was never
    // replaced and sat there on a page that was fully selected and ready to add
    // to cart. Retried because the custom element may not have upgraded yet.
    function syncNow() {
        var idInput = form.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
        if (idInput && idInput.value) applyVariant(idInput.value);
    }
    syncNow();
    setTimeout(syncNow, 300);
    setTimeout(syncNow, 1200);

    form.addEventListener('variant:changed', function (event) {
        var variant = event.detail && event.detail.variant;
        var pendingLabel = number.getAttribute('data-sku-pending-label') || 'Select Options';
        if (selectionIncomplete()) {
            setTimeout(function () {
                number.textContent = pendingLabel;
                number.classList.add('product-meta__identity-value--pending');
                number.disabled = true;
                number.setAttribute('data-product-bin-value', '');
                container.style.display = '';
                if (binWrap) binWrap.hidden = true;
            });
            return;
        }
        var sku = variant ? skuById[String(variant.id)] : null;
        var bin = variant ? binById[String(variant.id)] : null;
        // setTimeout, not requestAnimationFrame: rAF is suspended in a
        // background tab, so a variant chosen there would keep the previous
        // SKU until the tab was focused again. Zero delay still lands after the
        // theme's own synchronous handler.
        setTimeout(function () {
            if (sku) {
                number.textContent = sku;
                number.setAttribute('data-copy-sku', sku);
                number.setAttribute('data-product-bin-value', bin || '');
                number.disabled = false;
                // Drops the "Select Options" placeholder styling the first time
                // a real code lands.
                number.classList.remove('product-meta__identity-value--pending');
                container.style.display = '';
                // Collapse again on each change - an open bin from the previous
                // variant would otherwise read as this one's.
                // Keep the copy target in step, or it would paste the
                // location of whichever variant was loaded first.
                setBin(bin);
                if (binWrap) binWrap.hidden = true;
            } else {
                container.style.display = 'none';
            }
        });
    });
    }
})();

/* ---- Staff pick badge beside the review stars ----------------------------
   The rating is a Reviews.io app block, so the badge is rendered with the
   product title and moved onto that row once the app has drawn. Bounded
   polling rather than a MutationObserver, and it gives up quietly - the badge
   simply stays under the title if the stars never appear. */
(function () {
    // Left-to-right order on the row. Both badges use the same placement
    // contract, so this list is the only thing that decides which comes first.
    var badges = ['[data-staff-pick]', '[data-new-badge]']
        .map(function (sel) { return document.querySelector(sel); })
        .filter(Boolean);
    if (!badges.length) return;

    function reveal() {
        badges.forEach(function (b) { b.classList.remove('is-unplaced'); });
    }

    var tries = 0;
    var timer = setInterval(function () {
        tries++;
        var snippet = document.querySelector('.ruk_rating_snippet');
        // Insert into Shopify's outer wrapper, not the app's own render target,
        // so a re-render inside the app can't wipe the badge out.
        var row = snippet && snippet.closest('.shopify-app-block');
        if (row) {
            row.classList.add('has-staff-pick');
            // Each insert goes to the front, so walk the list BACKWARDS to end up
            // in the order declared above.
            badges.slice().reverse().forEach(function (b) {
                row.insertBefore(b, row.firstChild);
            });
            reveal();
            clearInterval(timer);
        } else if (tries > 25) {
            // Stars never arrived - show them where they stand rather than lose them.
            reveal();
            clearInterval(timer);
        }
    }, 200);
})();

/* ---- Staff cart view -----------------------------------------------------
   Reveals SKU and pick location on every cart line. Remembered per browser so
   staff don't re-tick it each time; shoppers never see it unless they find the
   toggle. Values reuse the existing [data-copy-sku] click-to-copy handler. */
(function () {
    var KEY = 'lux-staff-view';

    function on() {
        try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
    }
    function apply() {
        document.body.classList.toggle('lux-staff-view', on());

    }

    function set(state) {
        try {
            if (state) localStorage.setItem(KEY, '1');
            else localStorage.removeItem(KEY);
        } catch (e) { /* storage unavailable */ }
        apply();
    }

    // Unlock: ?staff=1 (bookmarkable) or Ctrl/Cmd+Alt+S. No visible control
    // for shoppers - the chip only exists once staff view is already on.
    try {
        var q = new URLSearchParams(location.search);
        if (q.has('staff')) set(q.get('staff') !== '0');
    } catch (e) { /* no URLSearchParams */ }

    document.addEventListener('keydown', function (event) {
        if (event.altKey && (event.ctrlKey || event.metaKey) && (event.key === 's' || event.key === 'S')) {
            event.preventDefault();
            set(!on());
        }
    });

    // Primary control: the Quantity column heading on the cart page.
    document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('[data-staff-trigger]')) set(!on());
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
    // Cart drawer/page re-renders replace the lines, so re-apply after updates.
    document.addEventListener('cart:updated', apply);
})();

/* ---- PDP shipping: international visitors --------------------------------
   Australian rates render server-side (the overwhelming majority of traffic).
   For everyone else we swap in the right line using Shopify's own IP-based
   country endpoint - first-party, no third-party geo service. Cached per
   session so it costs one request per visit.
   Runs for the product page's box at load, and for each quick view's box as
   it arrives (the fragment reviver calls window.luxInitOverseas). */
(function luxInitOverseas(panel) {
    window.luxInitOverseas = luxInitOverseas;
    if (!panel || panel.dataset.luxOverseasInit) return;
    panel.dataset.luxOverseasInit = '1';

    // The box's own product: a quick view's drawer, else the page section.
    var scopeOf = function () {
        return panel.closest('quick-buy-drawer, quick-buy-popover')
            || panel.closest('.shopify-section, section, form') || document;
    };
    var picker = panel.querySelector('[data-intl-country]');
    var select = panel.querySelector('[data-intl-country-select]');
    var esc = function (v) {
        return String(v).replace(/[&<>"]/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
    };

    // The postcode box and the domestic rates are for Australian shoppers only.
    function setDomestic(on) {
        // The postcode box, the priced line and the arrival line are
        // lux-shipping-box.js's, and the Christmas line lux-christmas.js's:
        // both show them for domestic shoppers only. data-domestic tells them
        // which this is, and the replayed estimate makes them look again.
        panel.querySelectorAll('.pdp-shipping__row:not([data-intl]):not([data-xmas]):not([data-arrival]):not([data-dispatch])')
            .forEach(function (el) { if (!el.querySelector('[data-intl-text]')) el.hidden = !on; });
        // The dispatch line is the engine's: off overseas, back only when it has a date.
        var dispatch = panel.querySelector('[data-dispatch]');
        if (dispatch) dispatch.hidden = !on || !dispatch.textContent.trim();
        var slot = panel.querySelector('[data-postcode-slot]');
        if (slot && !on) slot.hidden = true;
        panel.dataset.domestic = on ? '1' : '0';
        panel.dispatchEvent(new CustomEvent('lux:dispatch-render', { bubbles: true }));
    }

    function show(country, countryName) {
        if (!country) return;
        country = country.toUpperCase();

        // Reveal the picker as soon as we know they are overseas, and keep it up
        // afterwards so choosing Australia is reversible.
        if (picker && country !== 'AU') picker.hidden = false;
        // The select is empty until the link is clicked, so only sync it if filled.
        if (select && select.options.length && select.value !== country) {
            var has = Array.prototype.some.call(select.options, function (o) { return o.value === country; });
            if (has) select.value = country;
        }

        var row = panel.querySelector('[data-intl]');
        if (country === 'AU') { row.hidden = true; setDomestic(true); return; }

        var quoteOnly = (panel.dataset.quoteCountries || '')
            .split(',').map(function (c) { return c.trim().toUpperCase(); });
        var isBike = panel.dataset.isBike === '1';
        var tpl = panel.dataset.intlTemplate;
        var rate = country === 'NZ' ? panel.dataset.rateNz : panel.dataset.rateIntl;
        var name = countryName || (select && select.options.length && select.selectedIndex > -1 ? select.options[select.selectedIndex].text : '');
        var text = null, html = null;

        if (quoteOnly.indexOf(country) !== -1) text = panel.dataset.intlQuote;
        else if (isBike) {
            // The bike line takes {country} too, but never {price} - international
            // bike freight is quoted at checkout, so there is no number to show.
            var bike = panel.dataset.intlBike || '';
            if (bike.indexOf('{country}') !== -1 && name) {
                html = esc(bike).replace('{country}', '<strong>' + esc(name) + '</strong>');
            } else text = bike;
        }
        else if (tpl && rate && name) {
            // Country and price are the two things a shopper actually scans for,
            // so they are emitted bold. Both are escaped: the name comes from an
            // API response, not the theme settings.
            html = esc(tpl)
                .replace('{country}', '<strong>' + esc(name) + '</strong>')
                .replace('{price}', '<strong>' + esc(withCurrency(rate)) + '</strong>');
        }
        else text = country === 'NZ' ? panel.dataset.intlNz : panel.dataset.intlStandard;
        if (!text && !html) return;

        // Estimated import duty, from the rate the Checkout Mods app charges
        // at checkout (custom.usa_tariff mirror). The dollar figure multiplies
        // the rate by the GOODS SUBTOTAL of the same Storefront cart that
        // priced the shipping - per selected variant, and in the currency the
        // API answered with, never a number this (possibly cached-for-another-
        // market) page rendered. Until that arrives, the percentage.
        function tariffSuffix(c, goods) {
            if (c !== 'US') return '';
            if (panel.dataset.usaTariffEnabled === '0') return '';
            var trate = parseFloat(panel.dataset.usaTariffRate);
            if (!(trate > 0)) return '';
            if (goods && goods.amount > 0 && goods.currency) {
                var amt = trate * goods.amount;
                var money;
                try {
                    money = new Intl.NumberFormat('en', { style: 'currency', currency: goods.currency, currencyDisplay: 'narrowSymbol' }).format(amt);
                } catch (e) { money = amt.toFixed(2) + ' ' + goods.currency; }
                return ' <span data-lux-duty>+ est. <strong>' + money + '</strong> import tariffs at checkout</span>';
            }
            return ' <span data-lux-duty>+ est. ' + Math.round(trate * 1000) / 10 + '% import tariffs at checkout</span>';
        }

        var target = row.querySelector('[data-intl-text]');
        if (html) target.innerHTML = html; else target.textContent = text;
        var ts0 = tariffSuffix(country, null);
        if (ts0) target.innerHTML += ts0;
        row.hidden = false;
        setDomestic(false);

        // Then upgrade to the REAL rate. The settings line renders first so the
        // panel never sits empty or shifts; if the call fails, that line simply
        // stays. Quote-only countries are skipped deliberately: their zone rates
        // are placeholders that must never reach a shopper. (The USA left this
        // list on 17 Aug 2026 when its zone gained real USD bands.)
        if (quoteOnly.indexOf(country) !== -1) return;
        var priced = isBike ? panel.dataset.intlBikePriced : tpl;
        if (!priced || !name) return;
        function applyLive() {
        liveRate(country, name, function (r) {
            var money = formatRate(r);
            if (!money) {
                // No live rate came back. The commonest cause is not a network
                // failure but the product being absent from the sales channel the
                // Storefront lookup runs against - 7 of 16 new arrivals were, when
                // this was written, which is why a shopper in New Zealand saw
                // "$17.99 AUD" on a page priced in NZD.
                //
                // The settings rates are denominated in AUD, so leaving that line
                // up quotes a number in a currency that is not the shopper's. Say
                // what actually happens instead. Bikes already lead with their own
                // calculated-at-checkout wording, so they need nothing here.
                var unpriced = panel.dataset.intlUnpriced;
                var fallbackCcy = (picker && picker.dataset.rateCurrency || '').toUpperCase();
                var shopperCcy = (picker && picker.dataset.activeCurrency || '').toUpperCase();
                if (unpriced && !isBike && fallbackCcy && shopperCcy && fallbackCcy !== shopperCcy) {
                    var stillHere = select && select.options.length ? select.value : country;
                    if (stillHere !== country) return;
                    target.innerHTML = esc(unpriced)
                        .replace('{country}', '<strong>' + esc(name) + '</strong>');
                }
                return;
            }
            // Still the country we asked about? The shopper may have changed it
            // while the request was in flight.
            var current = select && select.options.length ? select.value : country;
            if (current !== country) return;
            var ts1 = tariffSuffix(country, r.goods);
            target.innerHTML = esc(priced)
                .replace('{country}', '<strong>' + esc(name) + '</strong>')
                .replace('{price}', '<strong>' + esc(money) + '</strong>') + ts1;
        });
        }
        applyLive();

        // A different variant can carry a different price and a different
        // weight band, so the whole line re-quotes when the buy grid commits
        // a selection (it dispatches change on its [data-variant-id] input).
        if (!panel._luxVariantHook) {
            panel._luxVariantHook = true;
            scopeOf().addEventListener('change', function (e) {
                if (!e.target || !e.target.matches || !e.target.matches('input[data-variant-id]')) return;
                applyLive();
            });
        }
    }

    // Every country, without shipping a country list. Intl.DisplayNames is backed
    // by the browser's own CLDR data, so walking AA..ZZ and keeping whatever
    // resolves to a real name gives the full set for free - nothing to embed,
    // nothing to keep up to date. 676 cheap lookups, and only on first click.
    // The skip list is regions CLDR still answers for but nobody ships to:
    // deprecated codes (Dahomey, Upper Volta, Rhodesia...) and groupings (EU, UN).
    // The picker lists exactly the countries the store SHIPS TO - the codes come
    // from the delivery profiles (embedded, because Liquid cannot read them) and
    // the names from the browser's CLDR data, so nothing but 710 bytes of codes
    // is shipped. Anything CLDR cannot name is dropped rather than shown as a
    // bare code.
    function buildCountries() {
        var codes = (picker && picker.dataset.shippable || '').split(/\s+/).filter(Boolean);
        if (!codes.length) return null;
        var dn;
        try { dn = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }); }
        catch (e) { return null; }
        var out = [];
        codes.forEach(function (code) {
            var name;
            try { name = dn.of(code); } catch (e) { return; }
            if (name && name !== code) out.push({ code: code, name: name });
        });
        out.sort(function (a, b) { return a.name.localeCompare(b.name); });
        return out;
    }

    function fallbackCountries() {
        return (picker && picker.dataset.fallbackList || '').split(',').map(function (pair) {
            var bits = pair.split(':');
            return bits.length === 2 ? { code: bits[0].trim().toUpperCase(), name: bits[1].trim() } : null;
        }).filter(Boolean);
    }

    // Every shipping rate in this store's delivery profiles is denominated in AUD
    // (checked: the New Zealand zone is 17.99 AUD, not NZD). Shopify converts it
    // at checkout, so the honest thing on the page is to name the currency rather
    // than guess at an FX rate that would not match what they are charged.
    function withCurrency(rate) {
        var rateCcy = (picker && picker.dataset.rateCurrency || '').toUpperCase();
        var active = (picker && picker.dataset.activeCurrency || '').toUpperCase();
        if (!rateCcy || !active || rateCcy === active) return rate;
        return rate + ' ' + rateCcy;
    }

    // ---- Live international rate -------------------------------------------
    // The rates in the theme settings are AUD placeholders. Shopify knows the
    // real number for the shopper's country AND presents it in their market's
    // currency, so ask it: a throwaway Storefront cart with a delivery address, read its
    // deliveryOptions. buyerIdentity.countryCode is what sets the presentment
    // currency, which is why the amount comes back in NZD for a NZ shopper even
    // though the zone rate is denominated in AUD.
    var token = panel.dataset.storefrontToken;
    var rateCache = {};

    var provinceMap = null;
    function addressFor(code, name) {
        if (provinceMap === null) {
            provinceMap = {};
            (picker && picker.dataset.provinces || '').split('|').forEach(function (pair) {
                var i = pair.indexOf(':');
                if (i > 0) provinceMap[pair.slice(0, i)] = pair.slice(i + 1);
            });
        }
        var addr = { country: name };
        if (provinceMap[code]) addr.province = provinceMap[code];
        return addr;
    }

    function liveRate(code, name, cb) {
        if (!token || !code || !name) { cb(null); return; }
        // Scoped to the panel's own section: quick-view templates, Algolia
        // result cards and page-builder buttons all carry [data-variant-id]
        // too, and a document-wide query can pick up one of THOSE products -
        // a 0.2kg accessory's band quoted on a 4kg frame's page.
        var idEl = scopeOf().querySelector('input[data-variant-id]');
        var variantId = (idEl && idEl.value) || panel.dataset.variantId;
        if (!variantId) { cb(null); return; }
        var key = code + ':' + variantId;
        if (rateCache[key] !== undefined) { cb(rateCache[key]); return; }
        try {
            var stored = sessionStorage.getItem('lux-rate2-' + key);
            if (stored) { rateCache[key] = JSON.parse(stored); cb(rateCache[key]); return; }
        } catch (e) { /* ignore */ }

        var query = 'mutation($input:CartInput!){cartCreate(input:$input){cart{cost{subtotalAmount{amount currencyCode}} deliveryGroups(first:1){nodes{deliveryOptions{title estimatedCost{amount currencyCode}}}}} userErrors{message}}}';
        var variables = {
            input: {
                lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }],
                buyerIdentity: {
                    countryCode: code,
                    // MailingAddressInput takes country NAMES, not codes. Countries
                    // Shopify considers to have provinces return no delivery options
                    // at all without one, so supply a representative province where
                    // the map has one.
                    deliveryAddressPreferences: [{ deliveryAddress: addressFor(code, name) }]
                }
            }
        };
        fetch('/api/2024-10/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
            body: JSON.stringify({ query: query, variables: variables })
        }).then(function (r) { return r.json(); }).then(function (d) {
            var cart = d && d.data && d.data.cartCreate && d.data.cartCreate.cart;
            var g = cart && cart.deliveryGroups.nodes;
            var opts = (g && g.length ? g[0].deliveryOptions : []) || [];
            // Pickup is free, so it always wins on price and is not what an
            // overseas shopper is asking about.
            opts = opts.filter(function (o) { return !/click|collect|pick\s*-?up|in.store/i.test(o.title); });
            var out = null;
            if (opts.length) {
                opts.sort(function (a, b) { return parseFloat(a.estimatedCost.amount) - parseFloat(b.estimatedCost.amount); });
                var c = opts[0];
                out = { amount: parseFloat(c.estimatedCost.amount), currency: c.estimatedCost.currencyCode };
                // The goods subtotal rides along for the duty estimate: it is
                // the one price source the page cache cannot mislabel, because
                // the API prices the cart for the buyer country it was asked
                // about - a US cart answers in USD whatever this page cached.
                var st = cart.cost && cart.cost.subtotalAmount;
                if (st) out.goods = { amount: parseFloat(st.amount), currency: st.currencyCode };
            }
            rateCache[key] = out;
            try { sessionStorage.setItem('lux-rate2-' + key, JSON.stringify(out)); } catch (e) { /* ignore */ }
            cb(out);
        }).catch(function () { cb(null); });
    }

    function formatRate(r) {
        if (!r) return null;
        if (!r.amount) return 'Free';
        // Never hand-roll this. A first cut used '$' + toFixed(2) and rendered
        // 5100 JPY as "$5100.00" - wrong symbol AND wrong precision, since yen
        // has no minor unit. Intl knows the symbol and the decimals for every
        // currency; narrowSymbol + the code mirrors how the theme prints prices
        // elsewhere ("£19.00 GBP", "$36.00 CAD").
        try {
            var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
                style: 'currency', currency: r.currency, currencyDisplay: 'narrowSymbol'
            }).format(r.amount);
            return r.currency ? money + ' ' + r.currency : money;
        } catch (e) {
            return r.amount.toFixed(2) + (r.currency ? ' ' + r.currency : '');
        }
    }

    var filled = false;
    function fillSelect() {
        if (filled || !select) return;
        var list = buildCountries() || fallbackCountries();
        if (!list.length) return;

        // Pin the handful of countries that actually get shipped to. 237 entries
        // alphabetically means a New Zealander scrolls past Afghanistan, Åland
        // and Albania to reach the second-biggest market. Order inside the pinned
        // group is the setting's order (by order volume), NOT alphabetical.
        var top = (picker && picker.dataset.topCountries || '').split(/\s+/).filter(Boolean);
        var byCode = {};
        list.forEach(function (c) { byCode[c.code] = c; });
        var pinned = top.map(function (code) { return byCode[code]; }).filter(Boolean);
        var pinnedSet = {};
        pinned.forEach(function (c) { pinnedSet[c.code] = true; });
        var rest = list.filter(function (c) { return !pinnedSet[c.code]; });

        function group(label, items) {
            if (!items.length) return null;
            // Only bother with a group heading when there is something to
            // separate - with no pinned list this stays a plain flat select.
            var g = document.createElement('optgroup');
            g.label = label;
            items.forEach(function (c) {
                var o = document.createElement('option');
                o.value = c.code; o.textContent = c.name;
                g.appendChild(o);
            });
            return g;
        }

        var frag = document.createDocumentFragment();
        if (pinned.length) {
            frag.appendChild(group('Most common', pinned));
            frag.appendChild(group('All countries', rest));
        } else {
            rest.forEach(function (c) {
                var o = document.createElement('option');
                o.value = c.code; o.textContent = c.name;
                frag.appendChild(o);
            });
        }
        select.appendChild(frag);
        filled = true;
        var current = null;
        try { current = sessionStorage.getItem('lux-country'); } catch (e) { /* ignore */ }
        if (current) select.value = current;
    }

    var openBtn = panel.querySelector('[data-intl-country-open]');
    if (openBtn && select) {
        openBtn.addEventListener('click', function () {
            fillSelect();
            select.hidden = false;
            openBtn.hidden = true;
            select.focus();
        });
        select.addEventListener('change', function () {
            var opt = select.options[select.selectedIndex];
            try { sessionStorage.setItem('lux-country', select.value); } catch (e) { /* ignore */ }
            try { sessionStorage.setItem('lux-country-name', opt ? opt.text : ''); } catch (e) { /* ignore */ }

            // If Shopify has a market for this country, hand over to its own
            // localization form: that reloads the page in the right market so
            // PRODUCT prices move to the local currency. Countries with no market
            // just update the shipping wording - there is no currency to move to,
            // and submitting would bounce them back unchanged.
            var markets = (picker && picker.dataset.marketCountries || '').split(/\s+/).filter(Boolean);
            var form = panel.querySelector('.pdp-shipping__loc-form');
            if (form && markets.indexOf(select.value) !== -1
                     && select.value !== (picker.dataset.activeCountry || '')) {
                var input = form.querySelector('[data-loc-country]');
                // A quick view comes back to the page it was opened on.
                var back = form.querySelector('input[name="return_to"]');
                if (back && panel.closest('quick-buy-drawer, quick-buy-popover')) back.value = location.pathname + location.search;
                if (input) { input.value = select.value; form.submit(); return; }
            }
            show(select.value, opt ? opt.text : '');
        });
    }

    // THE ACTIVE MARKET IS THE SOURCE OF TRUTH, not a separate IP lookup.
    //
    // This panel used to detect the country itself and cache it, which meant the
    // header could read "Australia (AUD $)" with AUD prices while the panel said
    // "Fast shipping to New Zealand from $22.00 NZD" on the same page. Two
    // detections, two answers. The market is what actually prices the order, so
    // it is what the panel follows. Setting the market from IP on first visit is
    // handled separately, below.
    //
    // A session pick still wins, but only when it is a country Shopify has NO
    // market for - those cannot move the market, so remembering them is the only
    // way the choice survives a page change.
    var marketCountry = picker && picker.dataset.activeCountry;
    var marketName = picker && picker.dataset.activeCountryName;
    var picked = null, pickedName = null;
    try {
        picked = sessionStorage.getItem('lux-country');
        pickedName = sessionStorage.getItem('lux-country-name');
    } catch (e) { /* storage unavailable */ }

    var markets = (picker && picker.dataset.marketCountries || '').split(/\s+/).filter(Boolean);
    if (picked && markets.indexOf(picked) === -1) show(picked, pickedName);
    else if (marketCountry) show(marketCountry, marketName);
})(document.querySelector('[data-pdp-shipping]'));

/* ---- Market/currency: Shopify already does it -----------------------------
   There was an auto-switch here that read the IP country and submitted the
   localization form on first visit. It was deleted because it never fired:
   Shopify assigns the market from IP itself, server-side, before any JS runs.
   Measured on a clean browser profile from a NZ address - the FIRST paint is
   already $20.00 NZD on both the live and staging themes, with no localization
   request and no cookie of ours.

   So the header, the prices and the shipping panel only ever need to read the
   ACTIVE MARKET. The bug that looked like "currency is not being detected" was
   the panel doing its OWN IP lookup and disagreeing with the market: the header
   could say Australia (AUD) while the panel said New Zealand ($22.00 NZD) on the
   same page. The panel now reads localization.country like everything else.

   Do not re-add a client-side switch without first checking a fresh profile -
   `curl` is not a fair test here, it gets served the default market. */

/* ---- Click to copy SKU / bin ---------------------------------------------
   The PDP buy grid binds this too, but its script only runs on product pages,
   so the cart's staff view had dead copy targets. Same flag means whichever
   loads first wins and it never double-binds. */
(function () {
    if (window.__buyGridCopyBound) return;
    window.__buyGridCopyBound = true;

    document.addEventListener('click', function (event) {
        var btn = event.target.closest && event.target.closest('[data-copy-sku]');
        if (!btn) return;
        event.stopPropagation();
        var value = btn.dataset.copySku;
        var write = navigator.clipboard && navigator.clipboard.writeText
            ? navigator.clipboard.writeText(value)
            : Promise.reject();
        write.then(function () {
            var original = btn.textContent;
            btn.textContent = 'Copied ✓';
            btn.classList.add('is-copied');
            setTimeout(function () {
                btn.textContent = original;
                btn.classList.remove('is-copied');
            }, 1200);
        }).catch(function () {
            // Clipboard blocked (insecure context/permissions) - select instead
            // so a manual copy still works.
            var range = document.createRange();
            range.selectNodeContents(btn);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        });
    });
})();

/* ---------------------------------------------------------------------------
   PDP upsell rail

   Cards are staff-curated (custom.cross_sells) and rendered server-side,
   already filtered to buyable products. No algorithmic top-up by design - the
   rail shows what was chosen for the product or the section is not rendered.

   Quick add itself is NOT handled here: each card contains a real
   <form is="product-form">, so the theme's own submit path runs and the cart
   drawer, cart count and variant:added event behave as they do everywhere else.
   All this needs to do is decide which variant that form posts.
   --------------------------------------------------------------------------- */
(function () {
    // Resolve the quick-add variant per OPTION AXIS, not from the clicked link.
    // A colour swatch's href points at the first available variant of that
    // colour, so trusting it committed a size the shopper never picked - the
    // Broc Raiford tyre went addable on a colour click with its width still
    // unchosen. Axes with only one available value are resolved for them; every
    // other axis has to be clicked.
    function upsellVariants(card) {
        if (card.__variants) return card.__variants;
        const holder = card.querySelector('[data-upsell-variants]');
        try {
            card.__variants = JSON.parse(holder.textContent);
        } catch (err) {
            card.__variants = [];
        }
        return card.__variants;
    }

    function upsellAxes(card) {
        const values = {};
        upsellVariants(card).forEach(function (v) {
            Object.keys(v.o).forEach(function (name) {
                (values[name] = values[name] || new Set()).add(v.o[name]);
            });
        });
        return values;
    }

    function upsellResolve(card) {
        const sel = card.__sel || {};
        const matches = upsellVariants(card).filter(function (v) {
            return Object.keys(sel).every(function (name) {
                return v.o[name] === sel[name];
            });
        });
        const input = card.querySelector('[data-upsell-variant]');
        const button = card.querySelector('[data-upsell-add]');
        // Exactly one, or the add is ambiguous
        const resolved = matches.length === 1 ? matches[0] : null;
        // Zero matches is a DIFFERENT state to an incomplete choice: the shopper
        // has picked a combination that does not exist as a buyable variant - the
        // colour is in stock, just not in that size. "Select Options" there is a
        // lie, it reads as though more input would help. Only buyable variants
        // are in this list, so a sold-out combination lands here too.
        const unavailable = matches.length === 0;
        if (input) input.value = resolved ? resolved.id : '';
        if (button) {
            button.disabled = !resolved;
            button.classList.toggle('is-unavailable', unavailable);
            // The label carries the reason the button is inert, so a greyed-out
            // button explains itself instead of just looking broken. Only write
            // when it actually changes - this subtree is observed elsewhere and
            // setting textContent replaces child nodes even for an equal value.
            const label = button.querySelector('[data-upsell-label]');
            if (label) {
                const next = resolved
                    ? (button.dataset.labelAdd || 'Add to Cart')
                    : unavailable
                    ? (button.dataset.labelUnavailable || 'Unavailable')
                    : (button.dataset.labelSelect || 'Select Options');
                if (label.textContent.trim() !== next) label.textContent = next;
            }
        }
        return resolved;
    }

    function initUpsellCard(card) {
        if (card.__upsellReady) return;
        card.__upsellReady = true;

        const axes = upsellAxes(card);
        card.__sel = {};
        Object.keys(axes).forEach(function (name) {
            // Only one value available on this axis - nothing for the shopper to
            // decide, so treat it as chosen and show it as such.
            if (axes[name].size === 1) card.__sel[name] = axes[name].values().next().value;
        });

        card.querySelectorAll('[data-option-name]').forEach(function (el) {
            const name = el.dataset.optionName;
            const value = (el.dataset.optionValue || '').toLowerCase();
            const auto = card.__sel[name] !== undefined && card.__sel[name] === value;
            if (el.classList.contains('card-option-pill')) el.classList.toggle('is-selected', auto);
            else el.classList.toggle('is-active', auto);
        });

        upsellResolve(card);
    }

    function markUpsellChoice(card, el) {
        const pairs = [];
        // Combo pills carry every non-colour axis they represent
        if (el.dataset.opts) {
            el.dataset.opts.split('||').forEach(function (part) {
                const i = part.indexOf(':');
                if (i > 0) pairs.push([part.slice(0, i).trim(), part.slice(i + 1).trim().toLowerCase()]);
            });
        } else if (el.dataset.optionName) {
            pairs.push([el.dataset.optionName, (el.dataset.optionValue || '').toLowerCase()]);
        }
        if (!pairs.length) return false;

        card.__sel = card.__sel || {};
        pairs.forEach(function (pair) { card.__sel[pair[0]] = pair[1]; });

        // Reflect the choice on every control belonging to the axes just set
        const names = pairs.map(function (p) { return p[0]; });
        card.querySelectorAll('[data-option-name]').forEach(function (other) {
            if (names.indexOf(other.dataset.optionName) === -1) return;
            const on = card.__sel[other.dataset.optionName] === (other.dataset.optionValue || '').toLowerCase();
            if (other.classList.contains('card-option-pill')) other.classList.toggle('is-selected', on);
            else other.classList.toggle('is-active', on);
        });
        return true;
    }

    document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        const control = e.target.closest('[data-upsell-card] .color-swatch__item, [data-upsell-card] .card-option-pill');
        if (!control) return;
        const card = control.closest('[data-upsell-card]');
        if (!card) return;

        // On an upsell these are variant pickers, not a way out of the page -
        // the shopper is mid-decision on the product they are already viewing.
        // The main image and title still navigate.
        e.preventDefault();

        initUpsellCard(card);
        if (markUpsellChoice(card, control)) upsellResolve(card);
    });

    // Resolve every card up front, so single-value axes show as chosen and the
    // tile's default .is-active (which only means "this is the featured image")
    // is cleared where the shopper still has a decision to make.
    function initUpsellCards() {
        document.querySelectorAll('[data-upsell-card]').forEach(initUpsellCard);
    }

    window.addEventListener('DOMContentLoaded', initUpsellCards);
    if (document.readyState !== 'loading') initUpsellCards();

    // Nothing chosen yet - never post an empty id (keyboard, or a stray Enter).
    document.addEventListener('submit', function (e) {
        const form = e.target.closest && e.target.closest('[data-upsell-form]');
        if (!form) return;
        const input = form.querySelector('[data-upsell-variant]');
        if (!input || input.value) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const card = form.closest('[data-upsell-card]');
        const firstChoice = card && card.querySelector('.color-swatch__item, .card-option-pill');
        if (firstChoice) firstChoice.focus();
    }, true);

})();

/* ---------------------------------------------------------------------------
   Editorial blog index

   Every article is server-rendered, so category filtering is instant and needs
   no request. The chips are still real links (to a blog, or to a /tagged/ URL
   once the archive is merged into Journal) - filtering intercepts the click, so
   the taxonomy stays crawlable while the page stays put.
   --------------------------------------------------------------------------- */
(function () {
    const root = document.querySelector('[data-editorial]');
    if (!root) return;

    const stream = root.querySelector('[data-editorial-stream]');
    const items = Array.from(root.querySelectorAll('[data-editorial-item]'));
    const chips = Array.from(root.querySelectorAll('[data-editorial-chip]'));
    const moreBtn = root.querySelector('[data-editorial-more]');
    const empty = root.querySelector('[data-editorial-empty]');
    const emptyCat = root.querySelector('[data-editorial-empty-cat]');
    if (!stream || !items.length) return;

    const step = items.filter(function (i) { return !i.hidden; }).length || 12;
    let category = 'all';
    let shown = step;

    function render() {
        const matching = items.filter(function (item) {
            if (category === 'all') return true;
            // A card lists every tag it carries in data-categories, delimited
            // with ~ so one key can't partially match another. data-category is
            // the single resolved category and remains the fallback for any card
            // rendered before that attribute existed.
            const all = item.dataset.categories;
            if (all) return all.indexOf('~' + category + '~') !== -1;
            return item.dataset.category === category;
        });

        items.forEach(function (item) { item.hidden = true; });
        matching.slice(0, shown).forEach(function (item) { item.hidden = false; });

        // Within a category the global lead/feature sizing is meaningless - the
        // article that led the whole page may not even be in this category.
        stream.classList.toggle('is-filtered', category !== 'all');

        if (moreBtn) moreBtn.hidden = matching.length <= shown;
        if (empty) {
            empty.hidden = matching.length > 0;
            const active = chips.find(function (c) { return c.dataset.editorialChip === category; });
            if (emptyCat && active) emptyCat.textContent = active.textContent.trim();
        }
    }

    // On a /tagged/ view the page already holds only one tag's articles, so the
    // other chips have nothing here to filter to - they must navigate instead.
    const scoped = !!root.querySelector('[data-editorial-scoped]');

    chips.forEach(function (chip) {
        chip.addEventListener('click', function (e) {
            if (scoped) return;
            // Anchor chips point at a crawlable destination; keep the shopper here.
            e.preventDefault();
            category = chip.dataset.editorialChip;
            shown = step;
            chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
            render();
            if (typeof markScrollers === 'function') markScrollers();
        });
    });

    if (moreBtn) {
        moreBtn.addEventListener('click', function () {
            shown += step;
            render();
        });
    }

    render();
})();

/* Journal search in the article sidebar. Deliberately not a <form> - the
   Algolia autocomplete app binds to form[role="search"] and replaces the markup
   with its own product search, which dropped the type=article scope. */
(function () {
    function go(root) {
        const input = root.querySelector('[data-journal-search-input]');
        const q = (input && input.value || '').trim();
        if (!q) { if (input) input.focus(); return; }
        window.location.href = '/search?type=article&q=' + encodeURIComponent(q);
    }
    document.addEventListener('click', function (e) {
        const btn = e.target.closest && e.target.closest('[data-journal-search-go]');
        if (!btn) return;
        go(btn.closest('[data-journal-search]'));
    });
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        const input = e.target.closest && e.target.closest('[data-journal-search-input]');
        if (!input) return;
        e.preventDefault();
        go(input.closest('[data-journal-search]'));
    });
})();

/* Article pages had no rendered title, so authors typed one into the body -
   10 of 14 sampled articles do. Now that the theme renders a real <h1>, drop
   the body's copy when it is the same heading, so the archive does not have to
   be hand-edited. Only removes on a confirmed match; anything else is left. */
(function () {
    const header = document.querySelector('.article-header__title');
    const body = document.querySelector('.article__content .rte');
    if (!header || !body) return;

    const norm = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const title = norm(header.textContent);
    if (title.length < 6) return;

    // Only the opening block - a matching heading further down is a real section
    const first = body.querySelector('h1, h2, h3');
    if (!first) return;
    const candidates = Array.from(body.children).slice(0, 3);
    if (candidates.indexOf(first) === -1) return;

    const found = norm(first.textContent);
    if (!found) return;

    const same = found === title
        || (found.length > 8 && (title.indexOf(found) === 0 || found.indexOf(title) === 0));
    if (!same) return;

    first.remove();
})();

/* ---------------------------------------------------------------------------
   Search placeholder

   The Algolia autocomplete app REPLACES the theme's search markup with its own
   .aa-Input - the theme's input[name="q"] is gone from the DOM entirely - so a
   placeholder set in Liquid never survives.

   Two observers, because Algolia fights back in two different ways:
     - it mounts asynchronously and re-mounts the input (focusing the bar wipes
       the placeholder), so a childList observer on body re-finds the input
     - it clears the attribute on the SAME node, which a childList observer
       never sees, so each input also gets an attributeFilter watcher

   Neither can loop: the write is skipped when the value already matches, so
   our own mutation ends the chain. Work is coalesced with setTimeout, not rAF
   (rAF is throttled in background tabs and frozen in the automation pane).
   --------------------------------------------------------------------------- */
(function () {
    const TEXT = 'What are you searching for?';
    const WATCHED = '__luxPlaceholderWatched';
    let queued = false;

    function apply() {
        queued = false;
        document.querySelectorAll('input.aa-Input').forEach(function (input) {
            if (input.placeholder !== TEXT) input.placeholder = TEXT;
            if (!input[WATCHED]) {
                input[WATCHED] = true;
                new MutationObserver(schedule).observe(input, {
                    attributes: true,
                    attributeFilter: ['placeholder'],
                });
            }
        });
    }

    function schedule() {
        if (queued) return;
        queued = true;
        setTimeout(apply, 0);
    }

    function watch() {
        apply();
        new MutationObserver(schedule).observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', watch);
    } else {
        watch();
    }
}());

/* ---------------------------------------------------------------------------
   Mobile search panel starts at the header's REAL bottom edge

   The panel is positioned with top: var(--header-height), and that variable is
   the wrong number twice over. header.liquid sets it inline from the header
   SECTION's own clientHeight, so it counts nothing stacked above the header -
   the announcement bar most of all - and the panel opened level with the header
   instead of below it, putting the logo and icons on top of the search field.
   It is also a one-shot read at parse time, so it never follows a rotate, a
   resize, or the bar growing to two lines on a narrow phone.

   getBoundingClientRect().bottom is the honest number: it already accounts for
   the announcement bar, a collapsed sticky header and any future banner without
   needing to know any of them exist. The CSS keeps --header-height as its
   fallback, so a failure here degrades to the old behaviour rather than
   dropping the panel to the top of the viewport.

   No scroll listener on purpose - body scrolling is locked while the panel is
   open, so the edge cannot move during that time. The class observer catches
   the one moment the number has to be right: as Algolia adds .aa-Detached.
   --------------------------------------------------------------------------- */
(function () {
    const header = document.querySelector('store-header') || document.querySelector('.header');
    if (!header) return;

    let last = -1;
    function update() {
        const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        if (bottom === last) return;
        last = bottom;
        document.documentElement.style.setProperty('--lux-search-top', bottom + 'px');
    }

    let queued = false;
    function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
            queued = false;
            update();
        });
    }

    update();
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(header);
    if (window.MutationObserver) {
        // Writes land on documentElement, not body, so this cannot re-trigger.
        new MutationObserver(schedule).observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
        });
    }
}());

/* ---------------------------------------------------------------------------
   Mobile search icon

   The header icon is a theme toggle-link pointing at #search-drawer, which
   does not exist since Algolia took over search, so the theme's own handler
   throws "setting 'open'" and does nothing. This listener runs first (capture
   on document) and stops it.

   Tap to open: clicks Algolia's detached search button. Algolia builds that
   button when it mounts, which can be before or after this file runs, so it
   is looked up at tap time rather than wired when it appears. Until Algolia
   has mounted (a slow connection), the icon follows its own link to the
   search page instead of doing nothing.

   Tap again to close: goes through Algolia's own Cancel control so its focus
   restoration and cleanup still run. Escape does not close it (Algolia does
   not listen on document).
   --------------------------------------------------------------------------- */
(function () {
    document.addEventListener('click', function (event) {
        if (!event.target.closest) return;
        const toggle = event.target.closest('a.js-search-mobile, [aria-controls="search-drawer"]');
        if (!toggle) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        if (document.body.classList.contains('aa-Detached')) {
            const cancel = document.querySelector('.aa-DetachedCancelButton');
            if (cancel) cancel.click();
            return;
        }

        const openButton = document.querySelector('.aa-DetachedSearchButton');
        if (openButton) {
            openButton.click();
            // Algolia does not focus the overlay's input when the button is
            // clicked from script, so typing would go nowhere.
            const overlayInput = document.querySelector('.aa-DetachedOverlay .aa-Input');
            if (overlayInput) overlayInput.focus();
            return;
        }
        // From 1000px Algolia uses the header box instead of the overlay.
        const inlineInput = Array.from(document.querySelectorAll('.aa-Input'))
            .find(function (input) { return input.offsetParent !== null; });
        if (inlineInput) {
            inlineInput.focus();
            return;
        }
        window.location.href = toggle.getAttribute('href') || '/search';
    }, true);
}());

/* ---------------------------------------------------------------------------
   Review stars for Algolia search results

   Ratings come from the Algolia record itself. Two sources, in order:

     meta.custom.review_rating / review_count  - preferred. The GROUPED totals,
       written by scripts/review-sync.mjs. Reviews.io pools related products
       (all six Odyssey R/F forks share one pool of 30 reviews), and these
       fields carry that pooled figure, so search agrees with the product page.

     meta.reviews.rating / rating_count        - fallback. Reviews.io's own
       metafields, which count only the SKUs on that one Shopify product. R32
       forks read 13 here versus the grouped 30.

   Either must be added to the Algolia app's indexed metafield list (Indexing >
   Metafields) and the products reindexed; until then the records carry no
   rating and no stars render.

   Fetching them from Reviews.io at render time was tried first and abandoned.
   Their rating-batch endpoint returns the whole pool, but which rows come back
   depends on the identifiers sent - an Algolia record carries only one
   variant's SKU, so the same product answered 3 reviews or 7 depending on which
   variant was in the panel, visibly wrong as results refresh on each keystroke.
   Batching several products per request was worse: the `lookup` field is a
   union across the whole request, so every product inherited the same total.
   Precomputing into a metafield avoids both traps.

   The <i> classes and icon font are Reviews.io's own, loaded sitewide by their
   core app embed, so these match the stars on product tiles.

   The product tile that calls read() and schedule() lives in
   snippets/algolia-search.liquid, registered through the Algolia app embed's
   template hook.
   --------------------------------------------------------------------------- */
(function () {
    // Reviews.io writes the rating as Shopify's `rating` type, whose value is a
    // JSON blob. Algolia may hand it back parsed or still as a string depending
    // on how the metafield is indexed, and a plain number is possible too.
    function toRating(raw) {
        if (raw == null) return NaN;
        if (typeof raw === 'number') return raw;
        if (typeof raw === 'object') return parseFloat(raw.value);
        const text = String(raw);
        if (text.charAt(0) === '{') {
            try {
                return parseFloat(JSON.parse(text).value);
            } catch (e) {
                return NaN;
            }
        }
        return parseFloat(text);
    }

    // Returns {rating, count} for an Algolia hit, or null when the record has no
    // rating - either the product has no reviews, or neither metafield pair is
    // in the index yet. Grouped totals win; Reviews.io's own fields are the
    // fallback so stars still render if only those are indexed.
    function read(item) {
        const meta = item && item.meta;
        if (!meta) return null;

        const pairs = [
            [meta.custom && meta.custom.review_rating, meta.custom && meta.custom.review_count],
            [meta.reviews && meta.reviews.rating, meta.reviews && meta.reviews.rating_count]
        ];
        for (let i = 0; i < pairs.length; i++) {
            const rating = toRating(pairs[i][0]);
            const count = parseInt(pairs[i][1], 10);
            if (rating > 0 && count > 0) return { rating: rating, count: count };
        }
        return null;
    }

    function starsHtml(rating, count) {
        let out = '';
        for (let i = 0; i < 5; i++) {
            // Their icon font only has quarter steps.
            const fill = Math.max(0, Math.min(1, rating - i));
            out += '<i aria-hidden="true" class="ruk-icon-percentage-star--' + (Math.round(fill * 4) * 25) + '"></i>';
        }
        return out + '<span class="lux-stars__count">(' + count + ')</span>';
    }

    function paint() {
        document.querySelectorAll('[data-lux-rating]').forEach(function (el) {
            const rating = parseFloat(el.dataset.luxRating);
            const count = parseInt(el.dataset.luxRatingCount, 10);

            // Autocomplete's virtual DOM recycles these spans as the shopper
            // types: it rewrites data-lux-rating/-count in place for whatever
            // product now occupies the slot, but the stars are our innerHTML, so
            // it has no reason to touch them. A once-per-element guard therefore
            // skipped the repaint and left the PREVIOUS product's count sitting
            // next to the new one - Odyssey Conical Headset showing 17 when its
            // own record says 10. Key the guard to the values, not the element,
            // so a recycled slot repaints and an unchanged one still costs
            // nothing.
            const painted = rating + '/' + count;
            if (el.dataset.luxRatingDone === painted) return;
            el.dataset.luxRatingDone = painted;

            // Clear rather than return: a slot recycled from a rated product to
            // an unrated one would otherwise keep the old stars.
            if (!(rating > 0) || !(count > 0)) {
                el.innerHTML = '';
                el.removeAttribute('aria-label');
                return;
            }
            el.innerHTML = starsHtml(rating, count);
            el.setAttribute('aria-label', rating.toFixed(1) + ' out of 5, ' + count + (count === 1 ? ' review' : ' reviews'));
        });
    }

    // The product tile calls this while the hit is still a virtual node, so
    // the paint has to wait for it to be mounted.
    let timer = null;
    function schedule() {
        clearTimeout(timer);
        timer = setTimeout(paint, 0);
    }

    window.luxReviewStars = { read: read, schedule: schedule, paint: paint };
    document.addEventListener('DOMContentLoaded', paint);
}());

/* ---------------------------------------------------------------------------
   Estimated dispatch date - product page and cart

   Turns the supplier lead-time integers into a date a shopper can act on, with a
   countdown to the daily cut-off while the item can still go out today.

   Computed in the BROWSER, never in Liquid. Shopify page-caches product pages, so
   a server-rendered date would be handed to someone days later still claiming
   "dispatched today".

   ONE engine drives both screens. Two copies of business-day arithmetic would
   drift, and the failure would be a product page and a cart quoting different
   dates for the same item.

   All arithmetic runs on a UTC date whose year/month/day MIRROR the store's
   calendar day. On a plain local Date a shopper in another timezone can cross
   midnight and shift the answer by a day.
   --------------------------------------------------------------------------- */
(function () {
    const STORE_TZ = 'Australia/Brisbane';
    const pad = n => (n < 10 ? '0' : '') + n;

    const dayFmt = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
    });

    // Store-local clock, derived through Intl rather than hardcoding +10 so this
    // survives the store moving. Brisbane itself has no daylight saving.
    function storeNow() {
        const parts = new Intl.DateTimeFormat('en-AU', {
            timeZone: STORE_TZ, year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        }).formatToParts(new Date());
        const o = {};
        parts.forEach(p => { if (p.type !== 'literal') o[p.type] = +p.value; });
        if (o.hour === 24) o.hour = 0;
        return o;
    }

    function engineFor(el) {
        const holidays = (el.dataset.dispatchHolidays || '').split(/\s+/).filter(Boolean);
        const cutoff = (function (raw) {
            const m = String(raw || '').match(/^\s*(\d{1,2})\s*:\s*(\d{2})/);
            return m ? { h: +m[1], m: +m[2] } : { h: 13, m: 0 };
        })(el.dataset.dispatchCutoff);

        const today = () => {
            const n = storeNow();
            return new Date(Date.UTC(n.year, n.month - 1, n.day));
        };

        const isBusinessDay = d => {
            const wd = d.getUTCDay();
            if (wd === 0 || wd === 6) return false;
            const key = d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
            return holidays.indexOf(key) === -1;
        };

        const nextBusinessDay = d => {
            const out = new Date(d.getTime());
            do { out.setUTCDate(out.getUTCDate() + 1); } while (!isBusinessDay(out));
            return out;
        };

        const addBusinessDays = (d, n) => {
            let out = new Date(d.getTime());
            for (let i = 0; i < n; i++) out = nextBusinessDay(out);
            return out;
        };

        const msToCutoff = () => {
            const n = storeNow();
            return (((cutoff.h - n.hour) * 60 + (cutoff.m - n.minute)) * 60 - n.second) * 1000;
        };

        // The day an order placed right now leaves the store, before lead time.
        const baseline = () => {
            const t = today();
            return (isBusinessDay(t) && msToCutoff() > 0) ? t : nextBusinessDay(t);
        };

        return {
            msToCutoff,
            estimate(lo, hi) {
                const base = baseline();
                return {
                    from: addBusinessDays(base, lo),
                    to: addBusinessDays(base, hi),
                    shipsToday: lo === 0 && base.getTime() === today().getTime()
                };
            }
        };
    }

    function countdownText(ms) {
        const total = Math.max(0, Math.floor(ms / 1000));
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        // Seconds are always shown. Without them the display sits unchanged for a
        // whole minute, which reads as broken rather than as a countdown.
        if (h > 0) return h + 'h ' + m + 'm ' + pad(s) + 's';
        return m > 0 ? m + 'm ' + pad(s) + 's' : s + 's';
    }

    // Renders into `row`/`text` whatever `getLead()` returns: [min, max], or null
    // to hide the row entirely.
    // `todayWord` leads the countdown ("Dispatched today if..."), `dateWord`
    // the dated line: the product page says "Dispatched", the cart keeps
    // "Estimated dispatch".
    function mount(configEl, row, text, getLead, todayWord, dateWord) {
        const engine = engineFor(configEl);
        let ticker = null;

        // Hands each estimate on (lux-christmas.js words its order-by dates
        // from it), so nothing else repeats the business-day maths.
        function announce(est, lead) {
            configEl.luxDispatch = { est: est, lead: lead };
            configEl.dispatchEvent(new CustomEvent('lux:dispatch-render', { bubbles: true }));
        }

        function render() {
            if (ticker) { clearInterval(ticker); ticker = null; }
            const lead = getLead();
            if (!lead) { row.hidden = true; announce(null, null); return; }

            const est = engine.estimate(lead[0], lead[1]);
            announce(est, lead);
            const wantCountdown = configEl.dataset.dispatchCountdown === '1';

            if (est.shipsToday && wantCountdown) {
                const tick = () => {
                    const left = engine.msToCutoff();
                    if (left <= 0) { render(); return; }   // cut-off passed - recompute
                    text.innerHTML = todayWord + ' <strong>today</strong> if you order within <strong>'
                        + countdownText(left) + '</strong>';
                };
                tick();
                ticker = setInterval(tick, 1000);
            } else if (est.from.getTime() === est.to.getTime()) {
                text.innerHTML = dateWord + ' <strong>' + dayFmt.format(est.from) + '</strong>';
            } else {
                text.innerHTML = dateWord + ' <strong>' + dayFmt.format(est.from)
                    + '</strong> - <strong>' + dayFmt.format(est.to) + '</strong>';
            }
            // A product page marked overseas (data-domestic 0, the overseas
            // swap above) keeps the line written but hidden, so switching back
            // to Australia shows the current date.
            row.hidden = configEl.dataset.domestic === '0';
        }

        render();
        return render;
    }

    /* ---- product page and quick view ----
       One initialiser, scoped to a root, for the same panel in two homes.
       The original ran once against document, which had two failure modes the
       quick view exposed: fragments injected after load were never filled
       (the dispatch row just stayed hidden), and the document-wide
       querySelectors would read the FIRST drawer's variants for every drawer
       - the same cross-product leak the variant-name line had. Scoping to
       the panel's own drawer kills both; the PDP passes document and behaves
       exactly as before. Exposed for the fragment reviver, which calls it
       after a quick view's scripts come alive. */
    const initShippingPanel = (root) => {
        const panel = root.querySelector('[data-pdp-shipping]');
        if (!panel || panel.dataset.dispatchEnabled !== '1') return;
        if (panel.dataset.luxDispatchInit) return; // one wiring per panel
        panel.dataset.luxDispatchInit = '1';
        const row = panel.querySelector('[data-dispatch]');
        const text = panel.querySelector('[data-dispatch-text]');
        if (!row || !text) return;
        const scope = panel.closest('quick-buy-drawer, quick-buy-popover') || document;
        const selectedLead = () => {
            const script = scope.querySelector('script[data-buy-grid-variants]');
            if (!script) return null;
            let list;
            try { list = JSON.parse(script.textContent); } catch (e) { return null; }
            const input = scope.querySelector('[data-variant-id]');
            const id = String((input && input.value) || panel.dataset.variantId || '');
            const v = list.find(x => String(x.id) === id);
            // Preorder and special order carry their own wording on the buy
            // grid, and a sold-out variant has nothing to promise.
            if (!v || v.status === 'out' || v.status === 'pre' || v.status === 'special') return null;
            if (v.lead_min == null || v.lead_max == null) return null;
            return [v.lead_min, v.lead_max];
        };
        const rerender = mount(panel, row, text, selectedLead, 'Dispatched', 'Dispatched');

        // The buy grid changes variants by click and emits no event.
        const grid = scope.querySelector('buy-grid');
        if (grid) grid.addEventListener('click', () => setTimeout(rerender, 60));
        document.addEventListener('variant:changed', () => setTimeout(rerender, 60));
    };
    initShippingPanel(document);
    window.luxInitShippingPanel = initShippingPanel;
    /* The compare table's availability popups quote the same estimate as
       the product page, so the engine and its formats are shared rather
       than copied (window.luxDispatch, read by lux-compare.js). */
    window.luxDispatch = { engineFor: engineFor, countdownText: countdownText, dayFmt: dayFmt };

    /* ---- cart ----
       Liquid has already rolled the lines up to one window: the largest lead
       across them, because an order ships when its slowest line is ready. The row
       is not rendered at all when any line has no lead time. */
    function mountCarts() {
        document.querySelectorAll('[data-cart-dispatch]').forEach(el => {
            if (el.dataset.dispatchEnabled !== '1' || el.dataset.dispatchMounted === '1') return;
            const text = el.querySelector('[data-dispatch-text]');
            if (!text) return;
            el.dataset.dispatchMounted = '1';
            mount(el, el, text, () => {
                const lo = parseInt(el.dataset.leadMin, 10);
                const hi = parseInt(el.dataset.leadMax, 10);
                return (isNaN(lo) || isNaN(hi)) ? null : [lo, hi];
            }, 'Dispatched', 'Estimated dispatch');
        });
    }
    mountCarts();

    // The drawer is not necessarily in the DOM when this first runs, and it
    // replaces its own innerHTML on cart:refresh - which throws away the mounted
    // row and its ticker. Listening for cart:refresh alone missed the initial
    // render, so watch the document instead and mount whatever appears. The
    // dispatchMounted flag keeps it idempotent.
    document.documentElement.addEventListener('cart:refresh', () => setTimeout(mountCarts, 60));
    new MutationObserver(records => {
        for (const r of records) {
            for (const node of r.addedNodes) {
                if (node.nodeType !== 1) continue;
                if (node.matches?.('[data-cart-dispatch]') || node.querySelector?.('[data-cart-dispatch]')) {
                    mountCarts();
                    return;
                }
            }
        }
    }).observe(document.documentElement, { childList: true, subtree: true });
}());

/* Hide the header wishlist bubble when the list is empty.

   The cart bubble beside it renders nothing at zero, but Swym writes a literal
   "0" into its count, so the two sat differently - one clean icon, one wearing
   a red "0". :empty cannot match a node containing "0", so the state is
   mirrored onto an attribute for CSS to act on.

   Watched rather than read once: Swym populates the count asynchronously after
   its session resolves, and updates it on every add and remove. */
(function hideEmptyWishlistBubble() {
    const sync = () => {
        const icon = document.querySelector('#swym-advanced-header-icon');
        const count = icon && icon.querySelector('.swym-header-icon-count');
        if (!icon || !count) return false;
        const value = count.textContent.trim();
        icon.setAttribute('data-lux-empty', (value === '' || value === '0') ? 'true' : 'false');
        return true;
    };

    if (!sync()) {
        const waiting = new MutationObserver(() => { if (sync()) start(); });
        waiting.observe(document.body, { childList: true, subtree: true });
        var stopWaiting = () => waiting.disconnect();
    }

    function start() {
        if (typeof stopWaiting === 'function') stopWaiting();
        const count = document.querySelector('#swym-advanced-header-icon .swym-header-icon-count');
        if (!count) return;
        new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
    }
    start();
})();

/* Quick view wishlist heart.

   The quick-view fragment renders its own heart into the buy-grid's Swym
   anchor (see product-buy-grid.liquid) because Swym only populates anchors it
   finds at page load. This wires it: the variant comes from the buy-grid
   form's own [data-variant-id] input at click time - the buy-grid keeps that
   input current as options are picked, so the saved variant is exactly what
   the drawer is displaying, with no cache to go stale.

   Delegated from document because drawers are injected on demand; the guard
   against double-add is Swym's own .swym-added class, which we set only on a
   confirmed save so a failed one never looks like it worked. */
document.addEventListener('click', function (e) {
    const btn = e.target.closest('.lux-qv-wishlist');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('swym-added')) return;
    if (!window._swat || typeof window._swat.addToWishList !== 'function') return;

    const grid = btn.closest('.buy-grid');
    const variantInput = grid && grid.querySelector('[data-variant-id]');
    const epi = variantInput && parseInt(variantInput.value, 10);
    const empi = parseInt(btn.getAttribute('data-product-id'), 10);
    const du = btn.getAttribute('data-product-url');
    if (!epi || !empi || !du) return;

    window._swat.addToWishList(
        { empi: empi, epi: epi, du: du, dt: btn.getAttribute('data-product-title') || undefined },
        function () {
            btn.classList.add('swym-added');
            btn.setAttribute('aria-pressed', 'true');
            if (typeof window._swat.renderWishlistCount === 'function') {
                try { window._swat.renderWishlistCount(); } catch (err) { /* count is cosmetic */ }
            }
            /* Only on a confirmed save, so HUB never counts a failed add. */
            if (typeof window.luxWishlistReport === 'function') {
                window.luxWishlistReport('add', {
                    variantId: epi,
                    productId: empi,
                    sku: btn.getAttribute('data-sku') || null
                });
            }
        },
        function () { /* leave the button unchanged so the failure is visible */ }
    );
});

/* Bring quick-view fragments to life.

   The drawer loads its content with innerHTML, and HTML parsed that way
   treats <script> as an inert node - so the buy-grid's element definition,
   which ships inside the fragment, never ran. The buy box LOOKED right
   (server-rendered state) while every behaviour behind it was dead: swatch
   clicks changed nothing, the variant input never moved, the status line
   stayed blank. The ATC still worked only because product-form is defined
   globally, which is what made the corpse convincing.

   Reviving a script means replacing the inert node with a freshly created
   one - browsers execute those. Each is marked so the replacement mutation
   cannot re-trigger itself, and the snippet's own customElements guard makes
   a second drawer open a no-op. Scoped to quick-buy elements; nothing else
   on the site injects scripts this way. */
(function reviveQuickViewScripts() {
    const revive = (host) => {
        host.querySelectorAll('script').forEach(function (old) {
            if (old.dataset.luxRevived) return;
            const fresh = document.createElement('script');
            /* Every attribute must survive the swap. The first version copied
               none, which quietly destroyed the buy-grid's JSON data script -
               type="application/json" became executable JS (a syntax error)
               and losing data-buy-grid-variants meant connectedCallback threw
               on its first querySelector, leaving the whole buy box inert
               again with a different cause. Preserving type also keeps
               genuine data scripts data. */
            for (const attr of old.attributes) fresh.setAttribute(attr.name, attr.value);
            fresh.dataset.luxRevived = 'true';
            fresh.textContent = old.textContent;
            old.replaceWith(fresh);
        });
    };
    new MutationObserver(function (muts) {
        for (const m of muts) {
            const t = m.target;
            const host = t && t.closest && t.closest('quick-buy-drawer, quick-buy-popover');
            if (host && host.querySelector('.buy-grid')) {
                revive(host);
                // The overseas swap and the dispatch engine ran at page load;
                // hand them the fragment's box (overseas first, so the
                // engine's first render already knows).
                if (window.luxInitOverseas) window.luxInitOverseas(host.querySelector('[data-pdp-shipping]'));
                if (window.luxInitShippingPanel) window.luxInitShippingPanel(host);
            }
        }
    }).observe(document.body, { childList: true, subtree: true });
})();

/* Header wishlist count, mirrored from Swym's clipped anchor.

   Swym only ever writes the count into the badge inside its own #swym-anchor
   (kept rendered but clipped offscreen for exactly this reason) - a second
   element carrying its class is never touched, so the theme's header bubble
   is copied, not shared. "0" becomes "" so the bubble hides at zero like the
   cart's beside it. */
(function mirrorWishlistCount() {
    const target = document.querySelector('.lux-wishlist-count');
    if (!target) return;
    /* lux-wishlist.js writes the count itself when it is the provider. */
    if (window.luxWishlistProvider === 'lux') return;

    const sync = () => {
        const source = document.querySelector('#swym-anchor .swym-anchor-badge');
        if (!source) return;
        const count = source.textContent.trim();
        target.textContent = (count === '0') ? '' : count;
    };

    const attach = () => {
        const source = document.querySelector('#swym-anchor .swym-anchor-badge');
        if (!source) return false;
        sync();
        new MutationObserver(sync).observe(source, { childList: true, characterData: true, subtree: true });
        return true;
    };

    if (!attach()) {
        const waiting = new MutationObserver(() => { if (attach()) waiting.disconnect(); });
        waiting.observe(document.body, { childList: true, subtree: true });
    }
})();

/* Quick view add to cart opens the cart drawer.

   The theme only opens the drawer for forms outside a .drawer, and the
   desktop quick view is the vendor quick-buy drawer restyled as a modal. So
   an add from it closes the quick view, and its cart:refresh (dispatched on
   <html> once the cart has loaded) is told to open the drawer. Listening on
   window in the capture phase runs before the cart drawer's own listener. */
(function () {
    let fromQuickView = false;
    document.addEventListener('variant:added', function (e) {
        const host = e.target.closest && e.target.closest('quick-buy-drawer');
        if (!host) return;
        fromQuickView = true;
        host.open = false;
    });
    window.addEventListener('cart:refresh', function (e) {
        if (!fromQuickView || !e.detail) return;
        fromQuickView = false;
        if (window.themeVariables && window.themeVariables.settings.cartType === 'drawer') e.detail.openMiniCart = true;
    }, true);
})();

/* Quick view gallery: thumb click swaps the stage image.

   Delegated, because the modal is fetched on demand. The stage image's
   srcset is removed on swap - left in place, the browser keeps preferring
   srcset over the new src and the image never changes. The vendor's own
   variant:changed swap rewrites src AND srcset together, so the two
   mechanisms coexist. */
document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.lux-qv-thumb');
    if (!thumb) return;
    const host = thumb.closest('quick-buy-drawer');
    const stage = host && host.querySelector('.quick-view__stage img');
    if (!stage) return;
    stage.removeAttribute('srcset');
    stage.src = thumb.getAttribute('data-full');
    host.querySelectorAll('.lux-qv-thumb.is-active').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
});

/* Quick view SKU line, kept live per selection.

   The buy-grid updates its own [data-util-sku] element, but that lookup is
   scoped INSIDE the buy-grid element and the modal's identity line sits
   above it, so it would never update - and the PDP's data-product-sku hooks
   are wired document-wide by theme.js, which is exactly the cross-drawer
   leak shape this file keeps having to fix. Delegated and scoped to the
   drawer that was clicked instead; pending until the grid resolves a real
   variant, mirroring the PDP. */
function luxUpdateQuickViewSku(host) {
    const el = host.querySelector('.lux-qv-sku');
    if (!el) return;
    const script = host.querySelector('script[data-buy-grid-variants]');
    if (!script) return;
    let list;
    try { list = JSON.parse(script.textContent); } catch (err) { return; }
    const grid = host.querySelector('buy-grid');
    if (grid && typeof grid.isIncomplete === 'function' && grid.isIncomplete()) {
        el.textContent = el.dataset.pendingLabel || 'Select Options';
        el.classList.add('is-pending');
        return;
    }
    const input = host.querySelector('[data-variant-id]');
    const v = list.find(function (x) { return String(x.id) === String(input && input.value); });
    if (v && v.sku) {
        el.textContent = v.sku;
        el.classList.remove('is-pending');
        el.disabled = false;
        el.setAttribute('data-copy-sku', v.sku);

        /* Pick location follows the selected variant. An absent bin drops
           data-copy-sku entirely rather than leaving it empty - otherwise the
           element stays a copy target and a click puts "" on the clipboard
           while still flashing "Copied ✓". Same rule as the PDP. */
        const binText = host.querySelector('[data-qv-bin-text]');
        if (binText) {
            binText.textContent = v.bin || '-';
            if (v.bin) binText.setAttribute('data-copy-sku', v.bin);
            else binText.removeAttribute('data-copy-sku');
        }
    }
}

/* Clicking the quick view SKU reveals the pick location, mirroring the PDP.
   Copying is already handled by the shared [data-copy-sku] listener, so this
   only owns the toggle. The panel opens even with no bin: returning early on
   an empty one left staff unable to tell "no location" from "the click did
   not register", which is why the PDP shows a dash instead. */
document.addEventListener('click', function (e) {
    const sku = e.target.closest && e.target.closest('.lux-qv-sku');
    if (!sku || sku.disabled) return;
    const host = sku.closest('quick-buy-drawer, quick-buy-popover');
    const bin = host && host.querySelector('[data-qv-bin]');
    if (bin) bin.hidden = !bin.hidden;
});

document.addEventListener('click', function (e) {
    const host = e.target.closest('quick-buy-drawer, quick-buy-popover');
    if (!host) return;
    setTimeout(function () { luxUpdateQuickViewSku(host); }, 80);
});

/* Resolve the SKU on OPEN as well as on click.

   A click handler alone was never enough: the section renders the SKU as
   "Select Options" and waited for the shopper to pick something, but a
   product whose options are all preselected - one colour, one size - gives
   them nothing to click, so the pending label was the final state. Every
   other field (price, variant name, Add to Cart) was already resolved,
   which is what made it look like a loading failure rather than a
   selection prompt.

   Retried across a few frames because the buy-grid element defines itself
   from a revived fragment script, so it may not have upgraded yet on the
   first tick. variant:changed is captured too, for selections made
   programmatically rather than by a real click. */
document.addEventListener('variant:changed', function (e) {
    const host = e.target && e.target.closest && e.target.closest('quick-buy-drawer, quick-buy-popover');
    if (host) luxUpdateQuickViewSku(host);
}, true);

(function luxQuickViewSkuOnOpen() {
    const wire = (el) => {
        if (el.dataset.luxSkuWired) return;
        el.dataset.luxSkuWired = 'true';
        new MutationObserver(function () {
            if (!el.hasAttribute('open')) return;
            [120, 400, 900].forEach(function (delay) {
                setTimeout(function () { luxUpdateQuickViewSku(el); }, delay);
            });
        }).observe(el, { attributes: true, attributeFilter: ['open'] });
    };
    const sweep = () => document.querySelectorAll('quick-buy-drawer, quick-buy-popover').forEach(wire);
    if (document.readyState !== 'loading') sweep();
    else document.addEventListener('DOMContentLoaded', sweep);
    new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
})();

/* Quick view elements live on <body>, not in the tile.

   The home page's carousels transform their slides, and a transformed
   ancestor becomes the containing block for position:fixed descendants - so
   a quick view opened from a carousel rendered INSIDE the carousel's
   stacking layer, sandwiched under the sections that follow it. Collection
   grids have no transforms, which is why the same dialog was fine there.
   Portaling the elements to body means no ancestor can ever trap them;
   the tile triggers keep working because toggle-button targets them by id.
   Every handler this file attaches to quick views is already delegated or
   closest()-scoped, so none of them care where the element lives. */
(function portalQuickViews() {
    /* Only move an element that is ACTUALLY trapped. Moving a custom element
       fires disconnectedCallback then connectedCallback, which resets the
       vendor's load state - and on a collection page, where nothing
       transforms, the move bought nothing and cost us that reset. Quick view
       then failed intermittently on freshly injected tiles (Load more) with
       "Cannot read properties of null" inside its own _load.

       A position:fixed descendant is only trapped when an ancestor
       establishes a containing block: transform, filter, perspective, or a
       will-change naming one. Carousels do; product grids do not. */
    const isTrapped = (el) => {
        for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
            const s = getComputedStyle(p);
            if (s.transform !== 'none' || s.filter !== 'none' || s.perspective !== 'none') return true;
            if (/transform|filter|perspective/.test(s.willChange)) return true;
        }
        return false;
    };

    const portal = (el) => {
        if (el.parentElement === document.body) return;
        if (el.hasAttribute('open')) return;
        if (!isTrapped(el)) return;
        document.body.appendChild(el);
    };
    const sweep = () => document.querySelectorAll('quick-buy-drawer, quick-buy-popover').forEach(portal);
    if (document.readyState !== 'loading') sweep();
    else document.addEventListener('DOMContentLoaded', sweep);
    new MutationObserver(function (muts) {
        for (const m of muts) {
            for (const n of m.addedNodes) {
                if (n.nodeType !== 1) continue;
                if (n.matches && n.matches('quick-buy-drawer, quick-buy-popover')) portal(n);
                else if (n.querySelectorAll) n.querySelectorAll('quick-buy-drawer, quick-buy-popover').forEach(portal);
            }
        }
    }).observe(document.body, { childList: true, subtree: true });
})();

/* Swym's login-prompt copy, rewritten in the store's own voice.

   The stock strings ("Your collections are to stay here forever!" /
   "Login to save your stuff for good and access them whenever, wherever!")
   are not editable anywhere we control: they are baked into the app's own
   storefront-layout bundle, and neither Swym app-embed block in
   settings_data.json exposes them - those blocks carry colours, radii,
   font sizes and positions only (checked field by field). So the override
   happens here.

   Replaced by SELECTOR, not by matching the old text: if Swym rewords the
   defaults in a future release, a text match would silently stop applying
   and the stock copy would reappear. The class names say exactly what each
   node is for, which is the more stable contract.

   The observer is scoped to the Swym render container and only starts on
   pages that actually have one, so this costs nothing on the rest of the
   site. It stays connected rather than disconnecting after first paint
   because Swym re-renders this block when the tab strip switches between
   Wishlist and Saved for later. */
(function luxSwymCopy() {
    const host = document.querySelector('#swym-wishlist-render-container');
    if (!host) return;

    /* The lists-empty selector is scoped to its carousel on purpose:
       .swym-storefront-layout-collection-empty is a generic empty-state
       class, and an unscoped match would put "no lists yet" copy into any
       other empty container Swym renders with it. */
    const COPY = {
        '.swym-storefront-layout-login-heading': 'Save your list',
        '.swym-storefront-layout-login-description': "Log in so it's there next time.",
        '.swym-storefront-layout-carousel .swym-storefront-layout-collection-empty':
            'No lists yet - group your saves into lists like a build, a birthday, or a maybe-later.',
        '.swym-storefront-layout-empty-wishlist-title': 'Nothing saved yet',
        '.swym-storefront-layout-empty-wishlist-description':
            "Hit the heart on any product to save it here - bikes, parts, whatever you're building next.",
    };

    const apply = () => {
        for (const [sel, text] of Object.entries(COPY)) {
            host.querySelectorAll(sel).forEach(function (el) {
                if (el.dataset.luxCopy === text) return;
                el.textContent = text;
                el.dataset.luxCopy = text;
            });
        }
    };

    apply();
    new MutationObserver(apply).observe(host, { childList: true, subtree: true });
})();

/* Tell the theme when Swym has put something in the cart.

   Swym's "Add To Cart" on the wishlist page POSTs to /cart/add.js itself
   (XHR) and then refreshes its own UI. The item really does land in the
   cart - but Swym fires none of the events this theme's header and drawer
   listen for, so the count bubble stayed empty and the drawer never
   opened. Verified by instrumenting the page: one POST to /cart/add.js,
   /cart.js reporting item_count 1 afterwards, and an empty event log.

   The theme's own contract after an add (theme.js) is: read /cart.js,
   dispatch cart:updated, then cart:refresh with openMiniCart. cart-drawer
   fetches the mini-cart section itself when detail.cart.sections is
   absent, so it does not need to be supplied here.

   Detection is a PerformanceObserver on resource timings rather than a
   patched XMLHttpRequest or a poll of /cart.js: it is read-only, needs no
   wrapper around a global the rest of the site uses, and fires exactly
   when the request finishes. buffered is left off so only adds that
   happen after this page loaded count. Scoped to pages carrying Swym's
   render container, so it costs nothing anywhere else. */
(function luxSwymCartSync() {
    /* Both containers: the shared-wishlist page is a separate template with
       its own render container and its own Add To Cart button, so it needs
       the same treatment or a recipient adding to cart gets the same dead
       header the owner used to. */
    if (!document.querySelector('#swym-wishlist-render-container, #swym-shared-wishlist-render-container')) return;
    if (typeof PerformanceObserver === 'undefined') return;

    const routes = (window.themeVariables && window.themeVariables.routes) || {};
    const settings = (window.themeVariables && window.themeVariables.settings) || {};
    const cartUrl = routes.cartUrl || '/cart';

    let timer = null;
    const notify = () => {
        clearTimeout(timer);
        /* Debounced: an "add all" would trip the observer once per item, and
           the theme only needs telling once the dust has settled. */
        timer = setTimeout(async function () {
            try {
                const response = await fetch(`${cartUrl}.js`);
                if (!response.ok) return;
                const cart = await response.json();
                const root = document.documentElement;
                root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
                root.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                    detail: { cart, openMiniCart: settings.cartType === 'drawer' },
                }));
            } catch (e) {
                /* A failed cart read is not worth breaking the page over -
                   the item is already added either way. */
            }
        }, 150);
    };

    new PerformanceObserver(function (list) {
        for (const entry of list.getEntries()) {
            if (/\/cart\/add(\.js)?(\?|$)/.test(entry.name)) {
                notify();
                return;
            }
        }
    }).observe({ type: 'resource' });
})();

/* "How it works" guide on the wishlist page.

   Deliberately not auto-opened: this page already fires a CLUB LUX panel
   and a chat widget on load, and a third uninvited overlay would be the
   one that finally annoys people. It opens from the link beside the
   intro copy and nowhere else.

   showModal() rather than a class toggle, so focus trapping, Esc-to-close
   and the backdrop come from the browser. It also renders in the top
   layer, which clears the loyalty panel's z-index of 999999 without this
   file having to bid against it.

   Delegated, so it survives the section being re-rendered by the theme
   editor while someone edits the step copy. */
(function luxWishlistGuide() {
    document.addEventListener('click', function (event) {
        const opener = event.target.closest('[data-lux-guide-open]');
        if (opener) {
            const dialog = opener.parentElement.querySelector('.lux-wishlist-guide');
            if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
            return;
        }

        const closer = event.target.closest('[data-lux-guide-close]');
        if (closer) {
            const dialog = closer.closest('.lux-wishlist-guide');
            if (dialog) dialog.close();
            return;
        }

        /* Click-outside. The dialog's own box IS the backdrop hit area -
           clicks on the card land on .lux-wishlist-guide__panel instead. */
        const dialog = event.target.closest('.lux-wishlist-guide');
        if (dialog && event.target === dialog) dialog.close();
    });
})();

/* Refuse to strike through a price that is not higher than the one being
   charged.

   product-item.liquid already guards this everywhere else on the site
   (compare_at_price > price), but Swym renders whatever compare-at the
   variant carries. A bulk audit of all 23,774 variants found 3,614 across
   1,261 products where compare-at sits BELOW the price - some at $0.00 -
   so the wishlist would have been the first surface to show a "was" price
   cheaper than the real one. That is misleading pricing, not a cosmetic
   slip, so it is defended here rather than waiting on the data cleanup.

   Marks rather than removes: leaving Swym's node in place keeps their own
   code free to read it, and the CSS hides it and drops the sale accent. */
(function luxSwymPriceGuard() {
    const host = document.querySelector('#swym-wishlist-render-container, #swym-shared-wishlist-render-container');
    if (!host) return;

    /* Two namespaces, because the two pages are built from different Swym
       component sets: the wishlist page uses storefront-layout-*, the
       shared page uses the classic swym-ui-component classes. Same defect
       on both, so both are checked. [was, now, row] */
    const PAIRS = [
        [
            '.swym-storefront-layout-grid-item-compare-price',
            '.swym-storefront-layout-grid-item-final-price',
            '.swym-storefront-layout-grid-item-price-variant',
        ],
        [
            '.swym-product-original-price',
            '.swym-product-final-price',
            '.swym-product-price',
        ],
    ];

    /* Strips currency symbols and thousands separators - "$1,299.99" and
       "$0.00" both have to parse, and 0 is a real value here, not a blank. */
    const toNumber = (el) => {
        if (!el) return null;
        const raw = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
        const n = parseFloat(raw);
        return Number.isFinite(n) ? n : null;
    };

    const apply = () => {
        PAIRS.forEach(function (pair) {
            const compareSel = pair[0];
            const finalSel = pair[1];
            const rowSel = pair[2];
            host.querySelectorAll(compareSel).forEach(function (compare) {
                const row = compare.closest(rowSel) || compare.parentElement;
                const final = row && row.querySelector(finalSel);
                const was = toNumber(compare);
                const now = toNumber(final);
                /* Unparseable prices are left alone: hiding a price we failed
                   to read would be a worse failure than showing it. */
                const invalid = was !== null && now !== null && was <= now;
                compare.classList.toggle('lux-price-invalid', invalid);
            });
        });
    };

    apply();
    /* childList/subtree only - watching attributes would make the class
       toggle above retrigger this observer. */
    new MutationObserver(apply).observe(host, { childList: true, subtree: true });
})();

/* Surface Swym's "Share Wishlist" as a visible button in the list header.

   Swym only offers it inside the ⋮ menu on a list, which is where share
   links go to die. This adds a labelled button next to that menu and
   drives Swym's OWN control rather than calling the share API directly:
   the button opens the menu, clicks their share item and lets their flow
   take over. Reusing their handler means the share URL, the modal and
   whatever analytics they fire all stay theirs.

   Gated on the same condition their menu item uses -
   _swat.platform.isLoggedIn() - because renderShareSingleWishlist() empties
   the options container for signed-out visitors. Without the same gate this
   would render a button with nothing behind it. */
(function luxSwymShareButton() {
    const host = document.querySelector('#swym-wishlist-render-container');
    if (!host) return;

    const ICON = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">'
        + '<circle cx="18" cy="5" r="2.6" stroke="currentColor" stroke-width="1.8"/>'
        + '<circle cx="6" cy="12" r="2.6" stroke="currentColor" stroke-width="1.8"/>'
        + '<circle cx="18" cy="19" r="2.6" stroke="currentColor" stroke-width="1.8"/>'
        + '<path d="M8.4 10.8l7.2-4.2M8.4 13.2l7.2 4.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'
        + '</svg>';

    const loggedIn = () => {
        try { return !!(window._swat && window._swat.platform && window._swat.platform.isLoggedIn()); }
        catch (e) { return false; }
    };

    /* Anchored on the ⋮ button itself, not on the title container Swym's
       source wraps it in - that wrapper is not in the rendered DOM, so
       scoping to it injected nothing at all. The button we need to sit
       beside is the only thing this has to find. */
    /* ONLY the opened-list header. Swym's share item comes from
       renderShareSingleWishlist(), which shares a single named LIST - the
       default "My Wishlist" header's ⋮ has no share option at all, so a
       button there opened a menu and found nothing to click. Restricting
       injection to the list header is also what stops the pair appearing
       together: the wishlist header's button used to escape its collapsed
       parent and paint over the list banner. */
    const HEADER = '.swym-storefront-layout-collection-list-header-content';

    const inject = () => {
        if (!loggedIn()) return;
        host.querySelectorAll('.swym-storefront-layout-collection-option-button').forEach(function (optionButton) {
            const parent = optionButton.parentElement;
            if (!parent || !optionButton.closest(HEADER)) return;
            /* One button per HEADER, not per ⋮. The list view renders a
               second option button inside the same header as the first, so
               a parent-level guard let both through and stacked two Share
               list buttons in the banner. */
            const scope = optionButton.closest(HEADER) || parent;
            let button = scope.querySelector('.lux-share-list');
            if (!button) {
                button = document.createElement('button');
                button.type = 'button';
                button.className = 'lux-share-list';
                button.innerHTML = ICON + '<span>Share list</span>';
                parent.insertBefore(button, optionButton);
            }

            /* Mirror the ⋮'s visibility. Opening a list collapses the
               wishlist header, but this button is absolutely positioned, so
               it escaped the collapse and kept painting over the list
               banner - two Share list buttons, one of them belonging to a
               header that is no longer on screen. Tying it to the ⋮ also
               means the button can never appear without the control it
               drives sitting behind it. */
            const optionVisible = optionButton.getBoundingClientRect().height > 0;
            button.classList.toggle('lux-share-list--hidden', !optionVisible);
            if (!optionVisible) return;

            /* Positioned off the ⋮'s MEASURED box rather than fixed offsets.
               The ⋮ is absolutely positioned and sits at a different height
               in the compact wishlist header than in the tall list banner,
               so any hardcoded top/right lines up in one and not the other.
               Matching centres keeps the two on one line whatever the
               header is doing, and re-running on each mutation means a late
               reflow does not strand the button. */
            if (optionButton.offsetParent === button.offsetParent) {
                const gap = 16;
                /* Measured against the shared offsetParent, NOT the ⋮'s own
                   parent. offsetLeft is already relative to offsetParent, so
                   mixing in a different element's clientWidth produced a
                   right value that was short by the difference between the
                   two boxes - which is why the button crept over the dots. */
                const anchor = optionButton.offsetParent;
                const optionRight = anchor.clientWidth - optionButton.offsetLeft - optionButton.offsetWidth;
                button.style.top = (optionButton.offsetTop + optionButton.offsetHeight / 2) + 'px';
                button.style.right = (optionRight + optionButton.offsetWidth + gap) + 'px';
                button.style.transform = 'translateY(-50%)';
            }
        });
    };

    inject();
    new MutationObserver(inject).observe(host, { childList: true, subtree: true });

    document.addEventListener('click', function (event) {
        const button = event.target.closest('.lux-share-list');
        if (!button) return;
        event.preventDefault();

        const container = button.closest('.swym-storefront-layout-collection-title-container');
        const optionButton = container && container.querySelector('.swym-storefront-layout-collection-option-button');
        if (!optionButton) return;

        const shareItem = () => document.querySelector('.swym-storefront-layout-action-tooltip-btn.share-collection-button');

        /* If the menu happens to be open already, clicking the ⋮ would close
           it - so take the item directly when it is there. */
        const open = shareItem();
        if (open) { open.click(); return; }

        optionButton.click();
        let tries = 0;
        const poll = setInterval(function () {
            const item = shareItem();
            if (item) { clearInterval(poll); item.click(); return; }
            if (++tries > 20) clearInterval(poll);
        }, 50);
    });
})();

/* Align the create-list box with the saved-list rows above it.

   The rows live inside .swym-storefront-layout-action-options, which is
   overflow-y:scroll with 2px of right padding; the create-list group sits
   OUTSIDE that scroller. So the rows lose the scrollbar's width plus that
   padding and the group does not, and the two boxes end at different
   x positions - flush on the left, ragged on the right.

   No fixed CSS value can fix this: the inset is 2px where scrollbars
   overlay the content (macOS default) and ~17px where they take real
   layout width, so a number that lines up on one machine is visibly wrong
   on another. The offset is measured off the row itself and mirrored onto
   the group, which is correct in both cases and re-measures on resize. */
(function luxSwymAddToListAlign() {
    const GROUP = '.swym-storefront-layout-create-collection-name-form-group';

    const align = () => {
        if (!document.querySelector(GROUP)) return;
        document.querySelectorAll(GROUP).forEach(function (group) {
            const layout = group.closest('.swym-storefront-layout-action-layout');
            if (!layout) return;
            const row = layout.querySelector('.swym-storefront-layout-action-collection-item-container');
            if (!row) return;
            group.style.marginRight = '0px';
            const delta = group.getBoundingClientRect().right - row.getBoundingClientRect().right;
            if (delta > 0.5) group.style.marginRight = Math.round(delta) + 'px';
        });
    };

    /* childList/subtree only - the inline margin written above is an
       attribute change, so this cannot retrigger itself. */
    new MutationObserver(align).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', align);
})();

/* Un-crop Swym's product thumbnails.

   Swym caches an image URL at save time that asks Shopify's CDN for a
   centre-cropped square (crop=center with matching width/height, or a
   _WxH filename suffix). The crop happens at the CDN, so the pixels are
   gone before any CSS runs - object-fit:contain on a square card cannot
   bring back a saddle's nose that was cropped off server-side. Confirmed
   by measurement: the delivered file is 316x316 and already tight on the
   product.

   Rewritten to an aspect-preserving request instead, letting the square
   card letterbox it. Shopify ignores unknown params and serves the
   original on a bad transform, so the worst case is the image we already
   had. srcset is dropped first - left in place the browser keeps
   preferring it and the new src never loads. */
(function luxSwymUncropImages() {
    const host = document.querySelector('#swym-wishlist-render-container, #swym-shared-wishlist-render-container');
    if (!host) return;

    const SELECTOR = 'img.swym-wishlist-image, img.swym-storefront-layout-grid-item-image';

    const fix = () => {
        host.querySelectorAll(SELECTOR).forEach(function (img) {
            if (img.dataset.luxUncropped) return;
            const src = img.getAttribute('src') || img.currentSrc;
            if (!src) return;
            let url;
            try { url = new URL(src, location.origin); } catch (e) { return; }
            if (!/\/cdn\/shop\/|cdn\.shopify\.com/.test(url.href)) return;

            url.searchParams.delete('crop');
            url.searchParams.delete('height');
            url.searchParams.set('width', '600');
            /* Shopify's legacy size suffix crops the same way the params do. */
            url.pathname = url.pathname.replace(/_\d+x\d*(?=\.[a-z]+$)/i, '');

            img.dataset.luxUncropped = 'true';
            img.removeAttribute('srcset');
            img.setAttribute('src', url.href);
        });
    };

    fix();
    new MutationObserver(fix).observe(host, { childList: true, subtree: true });
})();

/* Keep the wishlist layout tall enough for an opened list.

   Swym renders the opened-list panel as position:absolute inside
   .swym-storefront-layout-layout, so it contributes nothing to that
   element's height - which is sized by the default wishlist behind it.
   The layout also has overflow:hidden (deliberately: it clips the
   off-canvas panel that would otherwise widen the page). A list with more
   items than the default view is therefore taller than its own container
   and gets cut off. Measured on a 5-item list: panel 1394px inside a
   923px layout, so the second row lost 470px.

   Height is the only sane lever - the panel cannot be put back in flow
   without it stacking on top of the default content it overlays, and
   dropping overflow:hidden brings back the horizontal scrollbar. So the
   layout's min-height is synced to the panel while one is open, and
   released when it closes. */
(function luxSwymOpenListHeight() {
    const host = document.querySelector('#swym-wishlist-render-container');
    if (!host) return;

    let observed = null;
    const resizeObserver = typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(() => sync())
        : null;

    function sync() {
        const layout = host.querySelector('.swym-storefront-layout-layout');
        if (!layout) return;
        const panel = host.querySelector('.swym-storefront-layout-show-collection-list');
        const open = panel && panel.offsetHeight > 0;
        /* scrollHeight, not offsetHeight: the panel's own box can settle
           before its last row of images does, and offsetHeight then reports
           a height the content has already outgrown - leaving a slice of the
           list clipped. Ceil because the rect is fractional. */
        const needed = open ? Math.ceil(Math.max(panel.offsetHeight, panel.scrollHeight)) : 0;
        const next = open ? needed + 'px' : '';

        /* Only write on change - the observer below watches attributes, and
           an unconditional write would retrigger it forever. */
        if (layout.style.minHeight !== next) layout.style.minHeight = next;

        /* Re-point the ResizeObserver so a panel whose images finish loading,
           or whose list gains an item, grows the layout with it. */
        if (resizeObserver && panel !== observed) {
            if (observed) resizeObserver.unobserve(observed);
            if (panel) resizeObserver.observe(panel);
            observed = panel;
        }
    }

    /* Follow-up passes after an open. The panel reaches its final height only
       once the last row of product images has loaded, and that settle does not
       reliably surface as a ResizeObserver entry on the panel's own box - the
       first sync was landing 78px short of the finished list. */
    const syncSoon = () => {
        sync();
        [200, 600, 1500].forEach((delay) => setTimeout(sync, delay));
    };

    syncSoon();
    new MutationObserver(syncSoon).observe(host, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'hidden'],
    });
    /* Any image finishing inside the panel can change its height. */
    host.addEventListener('load', sync, true);
    window.addEventListener('resize', sync);
})();

/* Wishlist: most expensive first.

   Swym shows a list newest first, so a list built part by part opens on
   whatever was saved last (often grips). Inside an open list the items sit
   in a CSS grid, so each one gets a CSS order by price: Swym's nodes stay
   where Swym put them. A list's card shows its first three images, which
   are swapped for the three dearest items from Swym's own list data. */
(function luxSwymPriceOrder() {
    const host = document.querySelector('#swym-wishlist-render-container');
    if (!host) return;

    const toNumber = (el) => {
        if (!el) return null;
        const n = parseFloat((el.textContent || '').replace(/[^0-9.]/g, ''));
        return Number.isFinite(n) ? n : null;
    };

    function orderItems() {
        host.querySelectorAll('.swym-storefront-layout-items-container').forEach(function (grid) {
            const rows = Array.prototype.map.call(grid.children, function (el) {
                return { el: el, price: toNumber(el.querySelector('.swym-storefront-layout-grid-item-final-price')) };
            });
            /* Unread prices go last rather than guessing. */
            rows.sort(function (a, b) { return (b.price === null ? -1 : b.price) - (a.price === null ? -1 : a.price); });
            rows.forEach(function (row, i) {
                if (row.el.style.order !== String(i)) row.el.style.order = String(i);
            });
        });
    }

    let byList = null;
    let fetching = false;
    let signature = '';
    /* The cards and the open list both count: a list opened straight from a
       link renders no cards, and its banner still needs the data. */
    function cardSignature() {
        const cards = Array.prototype.map.call(host.querySelectorAll('.swym-storefront-layout-collection-grid-item[data-lid]'), function (card) {
            return card.getAttribute('data-lid') + ':' + card.textContent.replace(/\s+/g, ' ').trim();
        });
        const open = /#swym-collection:([\w-]+)/.exec(location.hash);
        const grid = open && host.querySelector('.swym-storefront-layout-show-collection-list .swym-storefront-layout-items-container');
        if (grid) cards.push('open:' + open[1] + ':' + grid.children.length);
        return cards.join('|');
    }
    function paint(imgs, items) {
        if (!items) return;
        Array.prototype.forEach.call(imgs, function (img, i) {
            const item = items[i];
            if (!item || !item.iu || img.getAttribute('src') === item.iu) return;
            img.setAttribute('src', item.iu);
            img.setAttribute('alt', item.dt || '');
        });
    }
    function paintCards() {
        if (!byList) return;
        host.querySelectorAll('.swym-storefront-layout-collection-grid-item[data-lid]').forEach(function (card) {
            paint(card.querySelectorAll('.swym-storefront-layout-collection-grid-item-image'), byList[card.getAttribute('data-lid')]);
        });
        /* The open list's banner carries no list id; Swym keeps it in the hash. */
        const open = /#swym-collection:([\w-]+)/.exec(location.hash);
        const panel = open && host.querySelector('.swym-storefront-layout-show-collection-list');
        if (panel) paint(panel.querySelectorAll('.swym-storefront-layout-collection-list-image'), byList[open[1]]);
    }
    function orderCards() {
        const swat = window._swat;
        const next = cardSignature();
        if (!next) return;
        if (next === signature) return paintCards();
        if (fetching || !swat || typeof swat.fetchLists !== 'function') return;
        fetching = true;
        signature = next;
        swat.fetchLists({
            callbackFn: function (lists) {
                fetching = false;
                byList = {};
                (lists || []).forEach(function (list) {
                    byList[list.lid] = (list.listcontents || []).filter(function (item) { return Number.isFinite(+item.pr); })
                        .sort(function (a, b) { return b.pr - a.pr; });
                });
                paintCards();
            },
            errorFn: function () { fetching = false; signature = ''; },
        });
    }

    let queued = false;
    function apply() {
        if (queued) return;
        queued = true;
        setTimeout(function () {
            queued = false;
            orderItems();
            orderCards();
        }, 120);
    }
    apply();
    /* childList only: the order and src writes above are attribute changes
       and must not retrigger this. */
    new MutationObserver(apply).observe(host, { childList: true, subtree: true });
    window.addEventListener('hashchange', apply);
})();

/* Wishlist: "Add all to cart" on an open list.

   Swym only adds one item at a time. This adds every item in the open list
   in one request, at the quantity saved. If that request fails (usually
   because one item is sold out) it adds them one by one, so the rest still
   go in, and says which didn't. luxSwymCartSync picks up the /cart/add.js
   requests and opens the drawer. */
(function luxSwymAddAll() {
    const host = document.querySelector('#swym-wishlist-render-container');
    if (!host) return;

    const openLid = () => {
        const m = /#swym-collection:([\w-]+)/.exec(location.hash);
        return m ? m[1] : null;
    };

    const last = { lid: null, text: '' };

    function inject() {
        const panel = host.querySelector('.swym-storefront-layout-show-collection-list');
        const grid = panel && panel.querySelector('.swym-storefront-layout-items-container');
        if (!grid || !openLid() || !grid.children.length) return;
        const existing = panel.querySelector('.lux-add-all');
        if (existing) {
            if (existing.dataset.shown !== String(grid.children.length)) {
                existing.dataset.shown = String(grid.children.length);
                showTotal(existing, openLid(), grid.children.length);
            }
            return;
        }
        const wrap = document.createElement('div');
        wrap.className = 'lux-add-all';
        wrap.dataset.shown = String(grid.children.length);
        wrap.innerHTML = '<p class="lux-add-all__total" hidden></p>'
            + '<button type="button" class="button button--primary lux-add-all__button">Add all to cart</button>'
            + '<p class="lux-add-all__note" role="status" aria-live="polite" hidden></p>';
        grid.parentElement.insertBefore(wrap, grid);
        showTotal(wrap, openLid(), grid.children.length);
        /* Swym redraws the panel when the list or cart changes, which takes
           this with it. Put the last message back so it isn't lost. */
        if (last.lid === openLid() && last.text) {
            const note = wrap.querySelector('.lux-add-all__note');
            note.textContent = last.text;
            note.hidden = false;
        }
    }

    /* The list's total at today's prices. Swym keeps prices in the store
       currency (AUD); a visitor shopping in another currency sees it
       converted at the rate Shopify uses for their cart. */
    const totals = {};
    function money(aud) {
        const cur = (window.Shopify && Shopify.currency) || {};
        const code = cur.active || 'AUD';
        const rate = code === 'AUD' ? 1 : (parseFloat(cur.rate) || 1);
        try {
            return new Intl.NumberFormat('en-AU', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(aud * rate)
                + (code === 'AUD' ? '' : ' ' + code);
        } catch (e) {
            return '$' + (aud * rate).toFixed(2);
        }
    }
    function paintTotal(wrap, t) {
        const el = wrap.querySelector('.lux-add-all__total');
        if (!el || !t) return;
        el.innerHTML = '<span>' + t.count + (t.count === 1 ? ' item' : ' items') + '</span><strong>' + money(t.sum) + '</strong>';
        el.hidden = false;
    }
    function showTotal(wrap, lid, shown) {
        const key = lid + ':' + shown;
        if (totals[key]) return paintTotal(wrap, totals[key]);
        details(lid).then(function (rows) {
            let sum = 0, count = 0;
            rows.forEach(function (it) {
                const qty = Math.max(1, +it.qty || 1);
                if (Number.isFinite(+it.pr)) sum += +it.pr * qty;
                count += qty;
            });
            totals[key] = { sum: sum, count: count };
            const current = host.querySelector('.lux-add-all');
            if (current) paintTotal(current, totals[key]);
        }, function () {});
    }

    function details(lid) {
        return new Promise(function (resolve, reject) {
            const swat = window._swat;
            if (!swat || typeof swat.fetchListDetails !== 'function') return reject(new Error('no swym'));
            swat.fetchListDetails({ lid: lid }, function (res) {
                const list = res && res.list ? res.list : res;
                resolve((list && list.listcontents) || []);
            }, reject);
        });
    }

    function add(items) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
        }).then(function (r) { return r.ok; }, function () { return false; });
    }

    async function addAll(wrap) {
        const lid = openLid();
        if (!lid) return;
        /* Looked up each time: the wrap may have been redrawn meanwhile. */
        const current = (sel) => host.querySelector('.lux-add-all ' + sel) || wrap.querySelector(sel);
        const say = (text) => {
            last.lid = lid;
            last.text = text;
            const note = current('.lux-add-all__note');
            note.textContent = text;
            note.hidden = !text;
        };
        const busy = (on) => { current('.lux-add-all__button').disabled = on; };
        busy(true);
        say('Adding to your cart...');
        try {
            const rows = (await details(lid)).filter(function (it) { return it && +it.epi; });
            if (!rows.length) { say('This list has nothing to add.'); return; }
            const line = (it) => ({ id: +it.epi, quantity: Math.max(1, +it.qty || 1) });
            if (await add(rows.map(line))) {
                say('Added ' + rows.length + (rows.length === 1 ? ' item' : ' items') + ' to your cart.');
                return;
            }
            const missed = [];
            for (const it of rows) {
                if (!(await add([line(it)]))) missed.push(it.dt || 'An item');
            }
            const added = rows.length - missed.length;
            say((added ? 'Added ' + added + ' to your cart. ' : '')
                + (missed.length ? 'Not available right now: ' + missed.join(', ') + '.' : ''));
        } catch (e) {
            say('Your list didn’t load. Try again in a moment.');
        } finally {
            busy(false);
        }
    }

    host.addEventListener('click', function (event) {
        const button = event.target.closest('.lux-add-all__button');
        if (button) addAll(button.closest('.lux-add-all'));
    });
    inject();
    new MutationObserver(inject).observe(host, { childList: true, subtree: true });
    window.addEventListener('hashchange', inject);
})();

/* An opened wishlist list dims the page around it (a wide box-shadow on the
   panel), so a click on that grey reads as "outside". It closes the list the
   same way as the panel's back arrow, and doesn't also act on whatever sits
   under the grey. Swym's own popups (share, item options, consent, create
   list) are left alone. */
document.addEventListener('click', function (e) {
    const panel = document.querySelector('.swym-storefront-layout-show-collection-list');
    if (!panel || !panel.offsetHeight || panel.contains(e.target)) return;
    if (e.target.closest('[class*="swym-storefront-layout-action"], [class*="popup"], [class*="modal"], [class*="consent"], [class*="toast"], [role="dialog"], dialog')) return;
    const back = panel.querySelector('.swym-storefront-layout-collection-list-back-button');
    if (!back) return;
    e.preventDefault();
    e.stopPropagation();
    back.click();
}, true);

/* Rescue shared-wishlist email links.

   Swym's share email appends swaction=openui to the link. That flag tells
   Swym to open the VIEWER'S OWN wishlist UI, so a recipient following the
   link is navigated straight off the shared page to /pages/wishlist and
   the shared list never renders - they see an empty wishlist instead of
   the list someone sent them.

   Isolated by request: the same hkey/lid renders the shared list fine
   without the flag, and fails identically WITH it on both the current and
   the previous page handle - so this is the flag, not the page rename.

   Stripped only on the share page, so links elsewhere that legitimately
   use swaction to open the wishlist UI are untouched. replaceState runs
   from a deferred script in <head>, before Swym's bundle initialises and
   reads location.search inside its own callback. */
(function luxSwymShareLinkFix() {
    if (!/\/pages\/share-wishlist/.test(location.pathname)) return;
    let url;
    try { url = new URL(location.href); } catch (e) { return; }
    if (url.searchParams.get('swaction') !== 'openui') return;
    /* Only safe to drop when there is a shared list to render instead. */
    if (!url.searchParams.get('hkey') && !url.searchParams.get('lid')) return;
    url.searchParams.delete('swaction');
    history.replaceState(null, '', url.pathname + url.search + url.hash);
})();

/* Quick-view overlays out of transformed ancestors.

   Every tile carries its own <quick-buy-popover> (phone) and
   <quick-buy-drawer> (desktop) INSIDE the tile's DOM. On plain collection
   grids that is fine, but home-page and cross-sell rails are carousels whose
   tracks are transformed - and a transformed ancestor becomes the containing
   block for position:fixed, so the overlay renders in-flow behind the page
   instead of on top of it.

   Moving them to <body> before they are first opened sidesteps every such
   ancestor at once. Safe to move: their id (which the trigger's
   aria-controls resolves globally), their href (fetched lazily on first
   open), and the theme's media-query classes all work identically from
   <body>. Custom elements re-run connectedCallback on the move, which is
   why this runs at scan time, never between open and close. */
(function luxUntrapQuickBuys() {
    function untrap(root) {
        (root.querySelectorAll ? root : document)
            .querySelectorAll('quick-buy-popover, quick-buy-drawer')
            .forEach(function (el) {
                if (el.parentElement === document.body) return;
                if (el.hasAttribute('open')) return; /* never mid-open */
                document.body.appendChild(el);
            });
    }
    function scan() { untrap(document); }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scan);
    } else { scan(); }
    /* Load more, facet re-renders and section refreshes add new tiles with
       new overlays; sweep additions rather than rebinding per feature. */
    new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
            if (muts[i].addedNodes.length) { scan(); return; }
        }
    }).observe(document.body, { childList: true, subtree: true });
})();

/* Keep the cart drawer open under Swym's save-for-later popup.

   The drawer is a focus-trap: any REAL pointer-down outside it deactivates
   the trap, whose onDeactivate closes the drawer. Swym's save-for-later
   dialog renders at body level - outside the drawer - so every tap on it
   (X, "Save For later", "No, thanks!") closed the cart, when the whole
   point of that moment is that the customer is mid-way through editing it.
   (Synthetic clicks never reproduced this: the trap listens for
   mousedown/touchstart, which element.click() does not fire.)

   The theme ships its own escape hatch: onDeactivate is a no-op while the
   element carries a `stop` attribute. So: hold `stop` on the drawer for
   exactly as long as an SFL dialog is in the DOM. No fighting the trap,
   no reimplementing its close paths - Esc, the X and the overlay all
   still work once the popup is gone. */
(function luxKeepCartOpenUnderSwymSfl() {
    var SFL = '.swym-sfl-popup-dialog';
    function sync() {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        if (document.querySelector(SFL)) drawer.setAttribute('stop', '');
        else drawer.removeAttribute('stop');
    }
    new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
    sync();
})();

/* Fit long tile titles into the two-line slot - whole title, same height.

   Long names rendered a third line that got sliced through the middle: the
   CSS -webkit-line-clamp has never worked on this store (display:-webkit-box
   computes to flow-root even when set inline, so it is normalised away, not
   overridden), leaving max-height to do the clipping.

   Truncating with an ellipsis fixed the slicing but lost the end of the
   name, which is the part that distinguishes these products - "(Custom
   Colours)" is exactly what a shopper is looking for. So instead of cutting
   the text, shrink it: step the type down until the whole title fits the two
   lines the tile already reserves. Ellipsis only as a last resort, if a name
   is still too long at the smallest size worth reading.

   The reserved height never changes, so card alignment holds. */
(function luxFitTileTitles() {
    var SEL = '.product-item-meta__title-text';
    var MAX_LINES = 2;
    var MIN_PX = 10.5;   /* below this it stops being readable on a tile */
    var STEP = 0.5;

    function lineCount(el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        /* One rect per rendered line box - the honest count. scrollHeight
           only says "taller than the box". */
        return range.getClientRects().length;
    }

    function fit(el) {
        var full = el.dataset.luxFullTitle || el.textContent.trim();
        el.dataset.luxFullTitle = full;
        el.textContent = full;
        el.style.fontSize = '';
        if (lineCount(el) <= MAX_LINES) return;

        var base = parseFloat(getComputedStyle(el).fontSize);
        for (var size = base - STEP; size >= MIN_PX; size -= STEP) {
            el.style.fontSize = size + 'px';
            if (lineCount(el) <= MAX_LINES) return;
        }

        /* Still too long at the floor - trim words rather than slice a line.
           Binary search so a 50-tile grid does not force hundreds of reflows. */
        var words = full.split(/\s+/), lo = 1, hi = words.length, best = 1;
        while (lo <= hi) {
            var mid = (lo + hi) >> 1;
            el.textContent = words.slice(0, mid).join(' ') + '\u2026';
            if (lineCount(el) <= MAX_LINES) { best = mid; lo = mid + 1; }
            else hi = mid - 1;
        }
        el.textContent = words.slice(0, best).join(' ') + '\u2026';
        var link = el.closest('a');
        if (link && !link.getAttribute('aria-label')) link.setAttribute('aria-label', full);
    }

    function run(root) { (root || document).querySelectorAll(SEL).forEach(fit); }

    var t;
    function debounced() { clearTimeout(t); t = setTimeout(function () { run(); }, 150); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
    else run();
    /* Line count follows column width, and Load more / facets / carousels
       bring their own tiles. */
    window.addEventListener('resize', debounced);
    new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) return debounced();
    }).observe(document.body, { childList: true, subtree: true });
})();

/* ---------------------------------------------------------------------------
   A hub and its upgrades move together in the cart

   The upgrades are separate cart lines because Shopify only charges for real
   line items, but they are not separate PURCHASES - the choice is also recorded
   on the hub's own line ("Driver Upgrade: 10T Titanium"). Remove the $96 driver
   line on its own and the hub still says titanium, so the build gets made with
   a titanium driver and never charged for it.

   So the upgrade rows carry no Remove of their own, and removing or requantifying
   a hub applies the same change to every line sharing its _Build token. The token
   is stamped at add-to-cart rather than matched on the hub's title, because two
   builds of the same hub in one cart are indistinguishable by title.

   Note this is presentation-layer safety. Someone hand-crafting a /cart/change
   request can still strip an upgrade, and only a server-side cart validation
   function could stop that - worth knowing, not worth an app on its own.
   --------------------------------------------------------------------------- */
(function () {
    function keysInBuild(build) {
        var sel = '[data-lux-build="' + (window.CSS && CSS.escape ? CSS.escape(build) : build) + '"]';
        return Array.prototype.map.call(document.querySelectorAll(sel), function (el) {
            return el.getAttribute('data-lux-line-key');
        }).filter(Boolean);
    }

    function refresh(json) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true, detail: { cart: cart },
            }));
            if (json && json.sections) cart.sections = json.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true, detail: { cart: cart, openMiniCart: false },
            }));
        });
    }

    function apply(updates) {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ updates: updates, sections: ['mini-cart'] }),
        }).then(function (r) { return r.json(); }).then(refresh);
    }

    document.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('a');
        if (!link) return;
        var row = link.closest('[data-lux-build]');
        // Only a hub leads a build. An upgrade's own controls are hidden, but
        // guard anyway so a stray one can never take the hub down with it.
        if (!row || row.classList.contains('line-item--upgrade')) return;

        var build = row.getAttribute('data-lux-build');
        var keys = keysInBuild(build);
        if (keys.length < 2) return;   // nothing attached, let the theme handle it

        var href = link.getAttribute('href') || '';
        var isRemove = link.classList.contains('line-item__remove-button')
            || /[?&]quantity=0(&|$)/.test(href);
        var qtyMatch = href.match(/[?&]quantity=(\d+)/);
        if (!isRemove && !qtyMatch) return;

        var qty = isRemove ? 0 : parseInt(qtyMatch[1], 10);
        if (isNaN(qty)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        var updates = {};
        keys.forEach(function (k) { updates[k] = qty; });
        apply(updates);
    }, true);
}());

/* The Tariffs & Fees line is added, priced and owned by the checkout
   apparatus (LUXBMX Checkout Mods); its cart-page stepper and Remove are
   hidden by the theme. This is the storefront half of the contract, both
   directions: a cart in the United States (Shopify.country, which geo-IP
   and the country picker both set) priced in USD with goods in it gets the
   fee line BEFORE checkout, so the cart total already tells the truth, and
   any other cart sheds it. Country, not currency: Bermuda and other
   countries are also priced in USD and owe no US tariff. The checkout extension remains the backstop for both cases.
   Idempotent and self-quieting: it listens to the theme's own cart:refresh,
   and once the cart matches the market it does nothing. */
(function () {
    var FEE_VARIANT = 52299937677613;
    var busy = false;

    function refresh(afterMutation) {
        if (!afterMutation) { busy = false; return; }
        var routes = (window.themeVariables && window.themeVariables.routes) || {};
        var cartPath = routes.cartUrl || '/cart';
        if (window.location.pathname === cartPath || document.querySelector('[data-lux-fee-key]')) {
            window.location.reload();
            return;
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var root = document.documentElement;
            root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
            busy = false;
        }).catch(function () { busy = false; });
    }

    function ensureFeeLine() {
        if (busy) return;
        var ccy = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        var country = (window.Shopify && window.Shopify.country) || '';
        if (!ccy || !country) return;
        busy = true;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var fee = null, goods = 0;
            (cart.items || []).forEach(function (it) {
                if (it.variant_id === FEE_VARIANT) fee = it;
                else goods++;
            });
            var wantFee = country === 'US' && ccy === 'USD' && goods > 0;
            if (wantFee && !fee) {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: FEE_VARIANT, quantity: 1 })
                }).then(function (r) { refresh(r.ok); }).catch(function () { busy = false; });
                return;
            }
            if (!wantFee && fee) {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: fee.key, quantity: 0 })
                }).then(function (r) { refresh(r.ok); }).catch(function () { busy = false; });
                return;
            }
            busy = false;
        }).catch(function () { busy = false; });
    }

    var debounce = null;
    function queueEnsure() {
        clearTimeout(debounce);
        debounce = setTimeout(ensureFeeLine, 400);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', queueEnsure);
    } else {
        queueEnsure();
    }
    document.documentElement.addEventListener('cart:refresh', queueEnsure);
})();

/* ─────────────────────────────────────────────────────────────
   Wishlist actions -> HUB
   ─────────────────────────────────────────────────────────────
   HUB ranks product popularity on units sold, which only ever describes what
   people managed to buy. A wishlist add is the same interest arriving earlier,
   and it covers things that were out of stock to buy at all. This posts each
   action to hub.luxbmx.com so /stock-demand can read intent as well as sales.

   Not routed through Swym's Klaviyo integration on purpose: that carried six
   events in thirty days against a wishlist button sitting on every product
   card, and emits nothing at all on removal.

   Swym's own event layer is the source. Everything is wrapped in
   SwymCallbacks because _swat and evtLayer do not exist until Swym has
   finished loading, and the listener shape is Swym's documented one:
   https://developers.getswym.com/docs/added-to-wishlist-event

   Fails silent by design. A shopper saving a product must never see an error
   because an analytics endpoint was unreachable. */
(function () {
    const ENDPOINT = 'https://hub.luxbmx.com/api/ingest/wishlist';

    /* A first-party random id, not a Swym internal. It only has to tell one
       shopper clicking five times from five shoppers clicking once, which is
       what HUB dedupes on. No PII, and it survives Swym version changes. */
    function anonId() {
        try {
            let id = localStorage.getItem('lux_wl_aid');
            if (!id) {
                id = (crypto.randomUUID && crypto.randomUUID()) ||
                     String(Date.now()) + Math.random().toString(36).slice(2);
                localStorage.setItem('lux_wl_aid', id);
            }
            return id;
        } catch (e) {
            return null; /* private browsing: HUB buckets these together */
        }
    }

    /* Swym has moved this payload around between versions, so read the variant
       from any of the shapes it has used rather than trusting one. The live
       store fires { detail: { d: {...} } } - probed 2026-08-20, and the miss
       cost us three weeks of events: without d.d in this chain, readProduct
       returned null on every real event and the drop was silent. epi is the
       variant, empi the product - Swym's own naming throughout its API.

       No `available` field: Swym's qty is the quantity wishlisted (always 1),
       not stock on hand. The HUB ingest route stamps availability server-side
       from its own inventory, which is fresher than anything the browser has. */
    function readProduct(d) {
        if (!d || typeof d !== 'object') return null;
        const src = d.d || d.product || d.data || d;
        const epi = src.epi || src.variantId || src.VariantId || src.variant_id;
        if (!epi) return null;
        return {
            variantId: epi,
            productId: src.empi || src.productId || src.ProductId || src.product_id || null,
            sku: src.sku || src.SKU || src.VariantSKU || null
        };
    }

    function send(action, payload) {
        const body = JSON.stringify({
            variantId: payload.variantId,
            productId: payload.productId,
            sku: payload.sku,
            action: action,
            anonId: anonId(),
            available: payload.available,
            occurredAt: new Date().toISOString()
        });
        try {
            /* NOT sendBeacon. A beacon carrying an application/json Blob to a
               cross-origin endpoint (www -> hub) needs a CORS preflight that
               beacons never perform, so the browser reports it queued and then
               drops it on the floor - which is how this pipeline ran silent
               while Swym's own dashboard logged hundreds of adds. keepalive
               gives the same survive-the-navigation behaviour with real CORS. */
            fetch(ENDPOINT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: body,
                keepalive: true,
                mode: 'cors'
            }).catch(function () { /* silent */ });
        } catch (e) { /* silent */ }
    }

    function bind() {
        const swat = window._swat;
        if (!swat || !swat.evtLayer || typeof swat.evtLayer.addEventListener !== 'function') return;
        const on = function (evt, action) {
            swat.evtLayer.addEventListener(evt, function (e) {
                const p = readProduct(e && (e.detail || e.data || e));
                if (p) send(action, p);
            });
        };
        /* Names from swat.JSEvents where it exists - the literals are what the
           live store's JSEvents resolved to when probed, kept as fallback. The
           SFL literal matters: the real name is sw:addedtoSFL (camel SFL), and
           the all-lowercase guess this shipped with matches nothing. */
        const names = swat.JSEvents || {};
        on(names.addedToWishlist || 'sw:addedtowishlist', 'add');
        /* Removal keeps the count honest. If a Swym version does not fire
           this, nothing happens - no listener, no error. */
        on(names.removedFromWishlist || 'sw:removedfromwishlist', 'remove');
        on(names.addedToSFL || 'sw:addedtoSFL', 'sfl');
    }

    /* The quick-view button calls _swat.addToWishList() directly rather than
       going through Swym's UI, and Swym documents sw:addedtowishlist as firing
       from its default UI - so that path would go unrecorded. Expose the
       reporter and let the quick-view handler call it on a confirmed save. */
    window.luxWishlistReport = send;

    if (window.SwymCallbacks) { window.SwymCallbacks.push(bind); }
    else { window.SwymCallbacks = [bind]; }
})();

/* The alternatives rail (custom.upsells) escalates when the product cannot
   actually be bought - that is the moment it stops being a suggestion.
   Liquid cannot decide this: with custom.disable_stock_feed set, supplier
   stock keeps product.available true while the buy grid correctly shows
   "Enquire about availability". The grid IS the verdict, so read it: its
   add-to-cart is hidden and the Klaviyo notify button takes over. Re-checked
   on variant change, since one colourway can be gone while another is not. */
(function () {
    var rail = document.querySelector('[data-alt-rail]');
    if (!rail) return;
    var grid = document.querySelector('.buy-grid');
    if (!grid) return;

    var slot = rail.querySelector('[data-alt-heading-slot]');
    var normal = rail.getAttribute('data-alt-heading') || '';
    var soldOut = rail.getAttribute('data-alt-heading-out') || '';

    function apply() {
        var atc = grid.querySelector('.product-form__add-button.buy-grid__atc');
        var notify = grid.querySelector('.klaviyo-bis-trigger.buy-grid__atc');
        // Unbuyable when the real add-to-cart is gone and notify stands in.
        var out = !!notify && !notify.hidden && (!atc || atc.hidden);
        rail.classList.toggle('upsell-rail--rescue', out);
        if (slot && soldOut) slot.textContent = out ? soldOut : normal;
        var btn = out ? ensureJump() : jump;
        /* Write only on a real change. el.hidden = x calls setAttribute, which
           queues a MutationRecord even when the value is identical - and this
           element lives inside the container the observer watches, so an
           unconditional write feeds itself forever. That is exactly what froze
           the page when the sold-out status line was being hidden here. */
        if (btn && btn.hidden !== !out) btn.hidden = !out;
    }

    /* Above the fold, the shopper sees "Enquire about availability" and nothing
       else - the alternatives are a screen or two down and most never reach
       them. This jump button sits with the buy box and says how many there
       are, so the sold-out moment offers a way forward instead of a dead end.
       Built once, shown and hidden by the same verdict. */
    var jump = null;
    /* One entry per alternative, with its title when the card exposes one
       (the product-item tile does, via its title link). */
    function altCards() {
        var track = rail.querySelector('[data-upsell-track]');
        if (!track) return [];
        var seen = {}, list = [];
        var links = track.querySelectorAll('a.product-item-meta__title[href*="/products/"]');
        if (!links.length) links = track.querySelectorAll('a[href*="/products/"]');
        links.forEach(function (a) {
            var h = a.getAttribute('href').split('?')[0];
            if (seen[h]) return;
            seen[h] = 1;
            list.push({ href: a.getAttribute('href'), title: (a.textContent || '').trim() });
        });
        return list;
    }
    function ensureJump() {
        if (jump) return jump;
        var actions = grid.querySelector('.buy-grid__actions') || grid;
        var alts = altCards();
        var n = alts.length;
        if (!n) return null;
        /* A single alternative is almost always the next model year of the
           same bike, so the button goes straight to it and says where it is
           going - a rail of one is a detour. */
        var single = n === 1 ? alts[0] : null;
        jump = document.createElement(single ? 'a' : 'button');
        if (single) jump.href = single.href; else jump.type = 'button';
        jump.className = 'buy-grid__jump-alts';
        var swapIcon =
            '<svg class="buy-grid__jump-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" ' +
            'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M4 8h13"/><path d="M14 5l3 3-3 3"/>' +
            '<path d="M20 16H7"/><path d="M10 13l-3 3 3 3"/></svg>';
        jump.innerHTML = swapIcon +
            '<span class="buy-grid__jump-label"></span>' +
            '<span class="buy-grid__jump-arrow' + (single ? ' buy-grid__jump-arrow--go' : '') +
            '" aria-hidden="true">' + (single ? '&#8594;' : '&#8595;') + '</span>';
        jump.querySelector('.buy-grid__jump-label').textContent = single && single.title
            ? 'Sold out: View ' + single.title
            : 'Sold out: View ' + n + ' top alternatives';
        if (!single) {
            jump.addEventListener('click', function () {
                rail.scrollIntoView({ behavior: 'smooth', block: 'start' });
                rail.classList.add('upsell-rail--flash');
                setTimeout(function () { rail.classList.remove('upsell-rail--flash'); }, 1400);
            });
        }
        actions.insertAdjacentElement('afterend', jump);
        return jump;
    }

    apply();
    new MutationObserver(apply).observe(grid, {
        subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'disabled']
    });
})();

/* Assembly video facade: load the YouTube player only when play is pressed. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-lux-yt]');
  if (!btn) return;
  var id = btn.getAttribute('data-lux-yt');
  var frame = document.createElement('iframe');
  frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
  frame.title = btn.getAttribute('aria-label') || 'Video';
  frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  frame.setAttribute('allowfullscreen', '');
  var wrap = document.createElement('div');
  wrap.className = 'lux-yt lux-yt--playing';
  wrap.appendChild(frame);
  btn.replaceWith(wrap);
});

/* ---------------------------------------------------------------------------
   Range slider over a Shopify "list" filter.

   Shopify only exposes two filter UI types, LIST and PRICE_RANGE, and
   PRICE_RANGE is price only. A decimal metafield like top_tube_length therefore
   always arrives as a checkbox list, which for measurements is a long column of
   near identical numbers.

   This element renders a two handle slider over that list and, on release,
   ticks the checkboxes inside the selected range. It then fires one `change`
   that bubbles to <facet-filters>, whose own handler rebuilds the URL from the
   form. So the standard Search & Discovery filter stays the source of truth and
   nothing here talks to the server.

   Handles move over POSITIONS, not values: the option list mixes grouped
   ranges ("20.50 - 20.59") with loose values ("21.25"), and the groups are
   uneven widths, so a linear scale would misrepresent the gaps.
--------------------------------------------------------------------------- */
class LuxFacetSlider extends HTMLElement {
  connectedCallback() {
    if (this._built) return;
    /* The facet panel is re-rendered wholesale after each filter change, so the
       element is rebuilt from scratch and reads its state back out of the DOM. */
    this.container = this.closest('.product-facet__filter-item, .collapsible-content, div');
    this.boxes = this._collectBoxes();
    if (this.boxes.length < 3) return; /* not worth a slider */
    this._built = true;
    this._render();
  }

  _collectBoxes() {
    let scope = this.parentElement;
    for (let i = 0; i < 4 && scope; i++) {
      const found = scope.querySelectorAll('input[type="checkbox"][name^="filter."]');
      if (found.length) {
        const list = [...found].map((el) => {
          const b = this._boundsFor(el);
          return b ? { el, lo: b.lo, hi: b.hi } : null;
        }).filter(Boolean);
        /* Sorted by value so handle positions run low to high regardless of the
           order Shopify listed the options in. */
        return list.sort((a, b) => a.lo - b.lo);
      }
      scope = scope.parentElement;
    }
    return [];
  }

  /* Labels read like "20.50 - 20.59 (26)" or "21.25 (38)", and carry a stray
     &lrm; plus sometimes a unit word. Numbers are taken from the label and the
     readout is built from those, rather than echoing the label text back, which
     dragged the direction mark and "Inch" along with it. */
  _boundsFor(input) {
    const label = (input.closest('.checkbox-container') || input.parentElement).querySelector('label');
    const text = (label ? label.textContent : '')
      .replace(/\u200e/g, '')
      .replace(/\([^)]*\)/g, '');
    const nums = text.match(/\d+(?:\.\d+)?/g);
    if (!nums || !nums.length) return null;
    if (/inch|"/i.test(text)) this._sawInch = true;
    return { lo: parseFloat(nums[0]), hi: parseFloat(nums[nums.length - 1]) };
  }

  /* Trim trailing zeros so 20.50 reads as 20.5 and 21.00 as 21. */
  _fmt(n) {
    return String(parseFloat(n.toFixed(3)));
  }

  _render() {
    const last = this.boxes.length - 1;
    const checked = this.boxes.map((o, i) => (o.el.checked ? i : -1)).filter((i) => i >= 0);
    this.lo = checked.length ? Math.min.apply(null, checked) : 0;
    this.hi = checked.length ? Math.max.apply(null, checked) : last;
    const unit = (this.dataset.unit === 'inch' || this._sawInch) ? '"' : '';

    this.innerHTML = [
      '<div class="lux-fslider__readout" aria-live="polite"></div>',
      '<div class="lux-fslider__track">',
      '  <span class="lux-fslider__fill"></span>',
      '  <input class="lux-fslider__input lux-fslider__input--lo" type="range" min="0" max="' + last + '" step="1" value="' + this.lo + '" aria-label="Smallest size">',
      '  <input class="lux-fslider__input lux-fslider__input--hi" type="range" min="0" max="' + last + '" step="1" value="' + this.hi + '" aria-label="Largest size">',
      '</div>',
      '<div class="lux-fslider__actions">',
      '  <button type="button" class="lux-fslider__apply" hidden>Apply</button>',
      '  <button type="button" class="lux-fslider__exact-toggle link" aria-expanded="false">Pick exact sizes</button>',
      '</div>'
    ].join('');

    this.readout = this.querySelector('.lux-fslider__readout');
    this.fill = this.querySelector('.lux-fslider__fill');
    this.inLo = this.querySelector('.lux-fslider__input--lo');
    this.inHi = this.querySelector('.lux-fslider__input--hi');
    this.unit = unit;
    this.apply = this.querySelector('.lux-fslider__apply');
    /* Baseline is whatever is already applied, so Apply only appears once the
       handles actually differ from the filtered result on screen. */
    this.baseLo = this.lo;
    this.baseHi = this.hi;
    this.apply.addEventListener('click', () => this._apply());

    /* The checkbox list is still the real control, just folded away by default
       so the facet is not the same information twice. The rows are tagged
       individually: they share a parent with this slider, so hiding that parent
       would take the slider down with it. */
    const rows = this.boxes
      .map((o) => o.el.closest('.checkbox-container') || o.el.closest('.block-swatch'))
      .filter(Boolean);
    rows.forEach((row) => row.classList.add('lux-fslider__exact-row'));
    if (rows.length) {
      const host = this.parentElement;
      this.querySelector('.lux-fslider__exact-toggle').addEventListener('click', (e) => {
        const open = host.classList.toggle('lux-exact-open');
        e.currentTarget.setAttribute('aria-expanded', open ? 'true' : 'false');
        e.currentTarget.textContent = open ? 'Hide exact sizes' : 'Pick exact sizes';
      });
    }

    const onMove = () => {
      let a = parseInt(this.inLo.value, 10);
      let b = parseInt(this.inHi.value, 10);
      if (a > b) { const t = a; a = b; b = t; }
      this.lo = a; this.hi = b;
      this._paint();
    };
    this.inLo.addEventListener('input', onMove);
    this.inHi.addEventListener('input', onMove);
    /* Deliberately no apply on `change`: with two handles that fired as soon as
       the first was released, re-rendered the panel mid-adjustment and threw
       away the second handle's position. Applying is now explicit. */
    this._paint();
  }

  _paint() {
    const last = this.boxes.length - 1 || 1;
    const loTxt = this._fmt(this.boxes[this.lo].lo);
    const hiTxt = this._fmt(this.boxes[this.hi].hi);
    this.readout.textContent = loTxt === hiTxt
      ? loTxt + this.unit
      : loTxt + this.unit + ' to ' + hiTxt + this.unit;
    this.fill.style.left = (this.lo / last) * 100 + '%';
    this.fill.style.right = 100 - (this.hi / last) * 100 + '%';
    if (this.apply) {
      const dirty = this.lo !== this.baseLo || this.hi !== this.baseHi;
      this.apply.hidden = !dirty;
    }
  }

  /* One bubbling change is enough: <facet-filters> reads the whole form. */
  _apply() {
    let fired = null;
    this.boxes.forEach((o, i) => {
      if (o.el.disabled) return;
      const want = i >= this.lo && i <= this.hi;
      const all = this.lo === 0 && this.hi === this.boxes.length - 1;
      const next = all ? false : want;
      if (o.el.checked !== next) { o.el.checked = next; fired = o.el; }
    });
    if (fired) fired.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
if (!window.customElements.get('lux-facet-slider')) {
  window.customElements.define('lux-facet-slider', LuxFacetSlider);
}

/* Shop Pay badge in the "Or 4 payments" row.
   Shopify's own installments banner (<shopify-payment-terms>) stays in the
   page but hidden, because the Learn more button inside its open shadow root
   is the only way to open the official Shop Pay modal, which renders in a
   portal on <body>. The badge clicks that button. Eligibility comes from the
   banner's own shopify-meta attribute, so the badge disappears on variants
   outside Shop Pay's price range instead of opening nothing. */
(function () {
  function termsEl() { return document.querySelector('shopify-payment-terms'); }

  function eligible(terms) {
    try {
      const meta = JSON.parse(terms.getAttribute('shopify-meta') || '{}');
      const id = Number(terms.getAttribute('variant-id'));
      const v = (meta.variants || []).find(function (x) { return x.id === id; });
      return v ? !!v.eligible : false;
    } catch (err) { return false; }
  }

  function syncBadges() {
    const terms = termsEl();
    const ok = !!terms && eligible(terms);
    document.querySelectorAll('[data-lux-shop-pay-learn-more]').forEach(function (b) { b.hidden = !ok; });
  }

  document.addEventListener('click', function (e) {
    const badge = e.target.closest('[data-lux-shop-pay-learn-more]');
    if (!badge) return;
    e.preventDefault();
    const terms = termsEl();
    const btn = terms && terms.shadowRoot && terms.shadowRoot.querySelector('button');
    if (btn) { btn.click(); return; }
    /* The component has not rendered (script blocked, still loading): show
       the banner itself so the shopper still gets Shopify's own line. */
    const source = document.querySelector('product-payment-terms');
    if (source) source.classList.add('lux-payment-terms-source--revealed');
  });

  window.addEventListener('DOMContentLoaded', function () {
    syncBadges();
    /* The theme's <product-payment-terms> swaps the banner out on variant
       change, so watch the wrapper rather than the banner element itself. */
    const source = document.querySelector('product-payment-terms');
    if (!source) return;
    new MutationObserver(syncBadges).observe(source, { childList: true, subtree: true, attributes: true, attributeFilter: ['variant-id', 'shopify-meta'] });
  });
})();

/* Pay in four, per variant, for products on the theme's own variant picker.
   The "Or 4 payments of" line is rendered once for the variant the page loaded
   on, so choosing another variant left a quarter of the wrong price. Each block
   ships a map of every variant's quarter, already formatted by Liquid's money
   filter, and this swaps the amount when the picker fires `variant:changed` on
   its form (not bubbling, hence the capture listener on document).
   Bikes and frames use the buy grid, which drives this line itself in
   paintPay4() because it also has to handle the "From" price before options
   are chosen; the `change` listener below just keeps the two in agreement. */
(function () {
  function setQuarter(variantId) {
    if (!variantId) return;
    var id = String(variantId);
    document.querySelectorAll('[data-pay4-amount]').forEach(function (el) {
      var mapEl = el.parentElement && el.parentElement.querySelector('[data-pay4-map]');
      if (!mapEl) return;
      var map;
      try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
      if (!map[id]) return;
      el.textContent = map[id];
      var word = el.parentElement.querySelector('[data-pay4-word]');
      if (word) word.textContent = 'of';
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[name="id"]')) setQuarter(t.value);
  });
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v) setQuarter(v.id);
  }, true);
})();

/* ---------------------------------------------------------------------------
   Add to cart: open the cart straight away, with a loading state

   The theme opens the cart drawer only once the add has come back AND it has
   fetched the whole cart again, about three seconds on a slow connection.
   The button's spinner stops when the add returns, so for the rest of that
   time nothing on the page said the item was going in, and a shopper who
   clicked the cart icon meanwhile opened the drawer as the page loaded it:
   empty. Shopper sessions show people then choosing the size again and
   adding a second time.

   So on a valid add, the drawer opens at once with "Adding to your cart…"
   over its old contents. The theme's own refresh then replaces the drawer's
   contents with the real cart, and the loading state goes. Opening the drawer
   first also lets the theme's in-drawer notification show: "Added to your
   cart", or the reason an add failed. If an add fails, the loading state
   clears and that message is what the shopper sees.

   Covers every form the theme's product-form handles, including the bike and
   frame buy grid, which rewrites the form but submits through the same
   handler. Adds made from inside a drawer are left alone, as the theme does.
   --------------------------------------------------------------------------- */
(function () {
    var ADDING = 'lux-cart-adding';
    var timer = null;

    function drawer() { return document.querySelector('cart-drawer'); }

    function stop() {
        clearTimeout(timer);
        var d = drawer();
        if (!d) return;
        d.classList.remove(ADDING);
        var note = d.querySelector('.lux-cart-adding__status');
        if (note) note.remove();
    }

    function start() {
        var d = drawer();
        if (!d) return;
        var content = d.querySelector('.drawer__content');
        if (content && !d.querySelector('.lux-cart-adding__status')) {
            var note = document.createElement('div');
            note.className = 'lux-cart-adding__status';
            note.setAttribute('role', 'status');
            note.innerHTML = '<span class="lux-cart-adding__spinner" aria-hidden="true"></span><span>Adding to your cart…</span>';
            content.prepend(note);
        }
        d.classList.add(ADDING);
        d.open = true;
        // A stalled request must not leave the drawer loading for ever.
        clearTimeout(timer);
        timer = setTimeout(stop, 15000);
    }

    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[is="product-form"]')) return;
        var vars = window.themeVariables && window.themeVariables.settings;
        if (!vars || vars.cartType !== 'drawer' || vars.pageType === 'cart') return;
        if (form.closest('.drawer')) return;
        if (!form.checkValidity()) return;
        start();
    }, true);

    // Success: the theme replaces the drawer's contents with the refreshed
    // cart (after a timer, sometimes after a fetch). Clear the loading state
    // the moment that replacement lands, so the old contents never flash.
    document.documentElement.addEventListener('cart:refresh', function () {
        var d = drawer();
        if (!d || !d.classList.contains(ADDING)) return;
        var watch = new MutationObserver(function () {
            watch.disconnect();
            stop();
        });
        watch.observe(d, { childList: true });
    });

    // Failure: the theme's notification carries the reason; show it.
    document.documentElement.addEventListener('cart-notification:show', function (e) {
        if (e.detail && e.detail.status === 'error') stop();
    }, true);
})();

/* Swym health check. When Swym's server stops answering (Oct 2026, after
   Swym's security lockdown every call failed), the wishlist page sat on
   skeleton cards and the header heart opened nothing. This asks Swym for
   the visitor's lists: no answer in 8 s, or an error, marks Swym down,
   which hides the wishlist links and shows the note on the wishlist page.
   A good answer clears it, so the site recovers by itself when Swym does.
   The result is kept for 10 minutes so other pages hide the heart at once
   and don't re-ask Swym on every page view. The wishlist page always
   re-asks, because that is where a stale "down" would cost the most. */
(function luxSwymHealth() {
    /* Our own wishlist (lux-wishlist.js) has no Swym to wait for: probing
       would always time out and hide the header link. */
    if (window.luxWishlistProvider === 'lux') return;
    const KEY = 'lux-swym-health';
    const TTL = 10 * 60 * 1000;
    const WAIT = 8000;
    const root = document.documentElement;
    const note = document.querySelector('[data-lux-swym-down-note]');

    function show(down) {
        root.classList.toggle('lux-swym-down', down);
        if (note) note.hidden = !down;
    }
    function save(down) {
        show(down);
        try { localStorage.setItem(KEY, JSON.stringify({ down: down, at: Date.now() })); } catch (e) {}
    }

    let last = null;
    try { last = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    const fresh = last && Date.now() - last.at < TTL;
    if (fresh) show(!!last.down);
    if (fresh && !note) return;

    let settled = false;
    const timer = setTimeout(function () { if (!settled) { settled = true; save(true); } }, WAIT);
    function settle(down) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        save(down);
    }
    function probe(swat) {
        try {
            swat.fetchLists({
                callbackFn: function () { settle(false); },
                errorFn: function () { settle(true); }
            });
        } catch (e) { settle(true); }
    }
    if (window._swat && window._swat.fetchLists) probe(window._swat);
    else {
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(probe);
    }
})();
